// Vedsanga — React Frontend with Supabase Auth
import { useState, useEffect, useRef } from "react";
import { supabase } from "./supabaseclient";
import { generateShlokaCard, downloadCard, shareCardWhatsApp } from "./ShlokaCard";
import JourneyPage from "./JourneyPage";
import OnboardingPage from "./OnboardingPage";
import HomePage from "./HomePage";
import BrowsePage from "./BrowsePage";
import LandingPage from "./LandingPage";
import SatsangPage from "./SatsangPage";
import BookClubPage from "./BookClubPage";
import RamayanaClubPage from "./RamayanaClubPage";
import PanchangPage from "./PanchangPage";
import JyotishPage from "./JyotishPage";
import PujaPage from "./PujaPage";
import VirtualPujaPage from "./VirtualPujaPage";
import PriestJoinPage from "./PriestJoinPage";
import AdminPage from "./AdminPage";
import PriestRegisterPage from "./PriestRegisterPage";
import PriestDashboardPage from "./PriestDashboardPage";
import PriestAltarPage from "./PriestAltarPage";
import PriestMonitorPage from "./PriestMonitorPage";
import MilanReportPage from "./MilanReportPage";
import ShaniReportPage from "./ShaniReportPage";
import KundaliReportPage from "./KundaliReportPage";
import usePushNotifications from "./usePushNotifications";
import ArchetypeQuizPage from "./ArchetypeQuizPage";
import MilanQuizPage from "./MilanQuizPage";
import AstrologerJoinPage from "./AstrologerJoinPage";
import AstroDeskPage from "./AstroDeskPage";
import ConsultPage from "./ConsultPage";
import DakshinaCard from "./DakshinaCard";
import MomentReportsPage from "./MomentReportsPage";


const css = `
  :root {
    --bg:#FFFFFF; --bg2:#FFFFFF; --bg3:#FFFFFF;
    --saffron:#E8832A; --gold:#C9953A;
    --cream:#1A1A1A; --text:#111111; --text-dim:#333333;
    --border:#E3E3E3; --glow:rgba(212,160,23,0.12); --radius:12px;
    --card-shadow: 0 2px 12px rgba(20,20,20,0.06);
    --card-shadow-hover: 0 6px 22px rgba(20,20,20,0.1);
  }
  .dark-section {
    --bg:transparent; --bg2:rgba(255,255,255,0.05); --bg3:rgba(255,255,255,0.04);
    --cream:#F2ECDD; --text:#F2ECDD; --text-dim:#B7AA8E;
    --border:rgba(227,178,76,0.24); --glow:rgba(232,131,42,0.15);
  }
  * { margin:0; padding:0; box-sizing:border-box; }
  body { background:var(--bg); color:var(--text); font-family: 'Inter', sans-serif; min-height:100vh; font-size: 22px; overflow-x:clip; }
  body::before { content:''; position:fixed; inset:0;
    background: none;
    pointer-events:none; z-index:0; }
  @media (max-width: 767px) {
    body::before { display:none; }
    body { overscroll-behavior: none; }
    * {
      backdrop-filter: none !important;
      -webkit-backdrop-filter: none !important;
      filter: none !important;
      -webkit-filter: none !important;
      animation-name: none !important;
      will-change: auto !important;
    }
  }
  .app { position:relative; z-index:1; display:flex; min-height:100vh; }

  /* Sidebar — v2 backup (saffron gradient, white text)
  .sidebar { width:260px; min-height:100vh;
    background:linear-gradient(175deg, #D4700A 0%, #E8832A 25%, #C96015 55%, #A84E0A 85%, #8B3E00 100%);
    border-right:none;
    display:flex; flex-direction:column; position:fixed; left:0; top:0; bottom:0; z-index:100;
    box-shadow:6px 0 40px rgba(139,62,0,0.5), 2px 0 12px rgba(232,131,42,0.3);
  }
  .sidebar::before { content:''; position:absolute; inset:0; pointer-events:none;
    background:
      radial-gradient(ellipse 130% 45% at 50% 0%, rgba(255,220,100,0.22) 0%, transparent 60%),
      radial-gradient(ellipse 100% 30% at 20% 50%, rgba(255,160,40,0.1) 0%, transparent 55%),
      radial-gradient(ellipse 90% 25% at 50% 100%, rgba(100,30,0,0.3) 0%, transparent 65%);
    z-index:0;
  }
  .sidebar > * { position:relative; z-index:1; }
  .sidebar-logo { padding:28px 24px 26px; border-bottom:1px solid rgba(255,255,255,0.18); text-align:center;
    background:radial-gradient(ellipse 100% 80% at 50% 0%, rgba(255,220,80,0.18) 0%, transparent 70%);
  }
  .logo-om { font-family:'Noto Sans Devanagari',serif; font-size:3.6rem; color:#FFE082; display:block; line-height:1; margin-bottom:10px; animation:pulse-om 3s ease-in-out infinite; }
  @keyframes pulse-om { 0%,100%{filter:drop-shadow(0 0 20px rgba(255,220,80,0.8)) drop-shadow(0 0 8px rgba(255,255,255,0.4))} 50%{filter:drop-shadow(0 0 40px rgba(255,220,80,1)) drop-shadow(0 0 18px rgba(255,255,255,0.7)) drop-shadow(0 0 60px rgba(255,180,30,0.5))} }
  .logo-name { font-family:'Cinzel Decorative',serif; font-size:1.32rem; color:#FFFFFF; letter-spacing:0.14em; text-shadow:0 2px 8px rgba(0,0,0,0.25), 0 0 24px rgba(255,220,80,0.4); }
  .logo-tagline { font-size:0.93rem; color:rgba(255,224,140,0.9); font-style:italic; margin-top:6px; font-family:'Cormorant Garamond',serif; letter-spacing:0.05em; text-shadow:0 1px 4px rgba(0,0,0,0.2); }
  .nav { padding:16px 0; flex:1; }
  .nav-item { display:flex; align-items:center; gap:12px; padding:13px 24px; cursor:pointer; transition:all 0.22s; border-left:3px solid transparent; font-size:1rem; color:rgba(255,255,255,0.88); font-weight:500; font-family:'Cormorant Garamond',serif; letter-spacing:0.04em; font-size:1.05rem; }
  .nav-item:hover { background:rgba(255,255,255,0.12); color:#FFFFFF; border-left-color:rgba(255,224,120,0.7); text-shadow:0 0 10px rgba(255,220,80,0.5); }
  .nav-item.active { background:rgba(255,255,255,0.18); color:#FFE082; border-left:3px solid #FFE082; font-weight:700; letter-spacing:0.05em; text-shadow:0 0 16px rgba(255,220,80,0.7), 0 1px 3px rgba(0,0,0,0.2); box-shadow:inset 0 1px 0 rgba(255,255,255,0.1), inset 0 -1px 0 rgba(0,0,0,0.1); }
  .nav-icon { font-size:1.18rem; width:22px; text-align:center; }
  .nav-item.active .nav-icon { filter:drop-shadow(0 0 8px rgba(255,220,80,0.9)); }
  .sidebar-footer { padding:16px 24px; border-top:1px solid rgba(255,255,255,0.15); font-size:0.9rem; color:rgba(255,224,140,0.75); text-align:center; font-family:'Cormorant Garamond',serif; letter-spacing:0.05em; text-shadow:0 1px 3px rgba(0,0,0,0.2); }
  */

  /* ── Sidebar base (structure only) ── */
  .sidebar { width:268px; min-height:100vh; display:flex; flex-direction:column; position:fixed; left:0; top:0; bottom:0; z-index:100; transition:background 0.4s, box-shadow 0.4s; }
  .sidebar::before { content:''; position:absolute; inset:0; pointer-events:none; z-index:0; transition:background 0.4s; }
  .sidebar::after  { content:''; position:absolute; top:0; right:0; bottom:0; width:1px; z-index:2; }
  .sidebar > * { position:relative; z-index:1; }

  /* ── LIGHT theme (default — white, one accent) ── */
  .sidebar.sb-light {
    background:#ffffff;
    box-shadow:1px 0 3px rgba(0,0,0,0.06);
  }
  .sidebar.sb-light::before { background:none; }
  .sidebar.sb-light::after  { background:var(--border); width:1px; }
  .sidebar.sb-light .sidebar-logo  {
    border-bottom:1px solid var(--border);
    background:none;
    padding-bottom:22px;
  }
  .sidebar.sb-light .logo-om       { color:var(--saffron); filter:none; }
  .sidebar.sb-light .logo-name     { color:#111111; text-shadow:none; font-size:1.35rem; }
  .sidebar.sb-light .logo-tagline  { color:var(--text-dim); font-size:0.95rem; }
  .sidebar.sb-light .nav-section-label { color:var(--text-dim); font-size:0.85rem; font-weight:700; text-shadow:none; }
  .sidebar.sb-light .nav-item      { color:#1a1a1a; font-size:1rem; text-shadow:none; }
  .sidebar.sb-light .nav-item:hover { background:rgba(232,131,42,0.08); color:#111111; border-left-color:var(--saffron); text-shadow:none; }
  .sidebar.sb-light .nav-item.active {
    background:rgba(232,131,42,0.1);
    color:var(--saffron); border-left:3px solid var(--saffron);
    box-shadow:none;
    animation:none;
  }
  .sidebar.sb-light .nav-icon      { opacity:0.85; filter:none; }
  .sidebar.sb-light .nav-item:hover .nav-icon  { opacity:1; filter:none; }
  .sidebar.sb-light .nav-item.active .nav-icon { opacity:1; filter:none; animation:none; }
  .sidebar.sb-light .sidebar-divider  { background:var(--border); }
  .sidebar.sb-light .sidebar-footer   { border-top:1px solid var(--border); color:var(--text-dim); font-size:0.9rem; text-shadow:none; }
  .sidebar.sb-light .sb-theme-toggle  { background:#fafafa; color:var(--text-dim); border:1px solid var(--border); font-size:0.9rem; }
  .sidebar.sb-light .sb-theme-toggle:hover { background:#f0f0f0; color:#111111; border-color:var(--saffron); }

  /* ── DARK theme (optional — temple at night) ── */
  .sidebar.sb-dark {
    background:linear-gradient(170deg, #2A1405 0%, #3D1E08 18%, #1E0D03 40%, #2C1606 65%, #180A02 100%);
    box-shadow:6px 0 48px rgba(0,0,0,0.55), 1px 0 0 rgba(210,150,30,0.4);
  }
  .sidebar.sb-dark::before {
    background:
      radial-gradient(circle, rgba(210,150,20,0.06) 1px, transparent 1px),
      radial-gradient(ellipse 180% 55% at 50% 0%,   rgba(200,130,20,0.18) 0%, transparent 55%),
      radial-gradient(ellipse 150% 40% at 50% 100%, rgba(180,100,10,0.12) 0%, transparent 60%);
    background-size:22px 22px, 100% 100%, 100% 100%;
  }
  .sidebar.sb-dark::after {
    background:linear-gradient(180deg, transparent 0%, rgba(220,170,40,0.6) 20%, rgba(255,200,60,0.45) 50%, rgba(220,170,40,0.6) 80%, transparent 100%);
  }
  .sidebar.sb-dark .sidebar-logo  { border-bottom:1px solid rgba(210,160,30,0.18); background:radial-gradient(ellipse 120% 90% at 50% 0%, rgba(200,140,20,0.22) 0%, transparent 65%); }
  .sidebar.sb-dark .logo-om       { color:#F5C842; }
  .sidebar.sb-dark .logo-name     { color:#F0C84A; text-shadow:0 0 18px rgba(240,190,50,0.7), 0 0 36px rgba(200,140,20,0.35), 0 1px 2px rgba(0,0,0,0.5); }
  .sidebar.sb-dark .logo-tagline  { color:rgba(230,185,80,0.65); }
  .sidebar.sb-dark .nav-section-label { color:rgba(200,150,40,0.38); }
  .sidebar.sb-dark .nav-item      { color:rgba(225,185,85,0.78); }
  .sidebar.sb-dark .nav-item:hover { background:rgba(200,140,20,0.12); color:#F5D060; border-left-color:rgba(220,170,40,0.5); text-shadow:0 0 14px rgba(245,200,60,0.5), 0 0 28px rgba(200,140,20,0.25); }
  .sidebar.sb-dark .nav-item.active { background:rgba(200,140,15,0.2); color:#FFE060; border-left:3px solid #E8B830; box-shadow:inset 4px 0 20px rgba(220,160,20,0.15), inset 0 0 28px rgba(200,140,10,0.08); animation:diya-flame-dark 2.8s ease-in-out infinite; }
  .sidebar.sb-dark .nav-icon      { opacity:0.72; filter:brightness(0.88) saturate(0.9); }
  .sidebar.sb-dark .nav-item:hover .nav-icon  { opacity:1; filter:brightness(1.1) saturate(1.2); }
  .sidebar.sb-dark .nav-item.active .nav-icon { opacity:1; filter:brightness(1.15) saturate(1.3) drop-shadow(0 0 4px rgba(245,200,60,0.5)); animation:icon-flame-dark 2.8s ease-in-out infinite; }
  .sidebar.sb-dark .sidebar-divider  { background:linear-gradient(90deg, transparent, rgba(200,150,30,0.18), transparent); }
  .sidebar.sb-dark .sidebar-footer   { border-top:1px solid rgba(200,150,30,0.12); color:rgba(200,155,50,0.38); }
  .sidebar.sb-dark .sb-theme-toggle  { background:rgba(255,255,255,0.07); color:rgba(220,175,60,0.65); border:1px solid rgba(210,155,30,0.2); }
  .sidebar.sb-dark .sb-theme-toggle:hover { background:rgba(255,255,255,0.12); color:#F5D060; }

  /* ── Shared sidebar elements ── */
  .sidebar-logo { padding:30px 24px 24px; text-align:center; }
  .logo-om      { font-family:'Noto Sans Devanagari',serif; font-size:5rem; display:block; line-height:1; margin-bottom:14px; animation:pulse-om 4s ease-in-out infinite; }
  @keyframes pulse-om {
    0%,100% { filter:drop-shadow(0 0 16px rgba(245,200,66,0.85)) drop-shadow(0 0 36px rgba(232,131,42,0.45)); }
    50%      { filter:drop-shadow(0 0 34px rgba(245,200,66,1))    drop-shadow(0 0 72px rgba(232,131,42,0.75)) drop-shadow(0 0 100px rgba(255,180,40,0.25)); }
  }
  .logo-name    { font-family:'Inter',sans-serif; font-size:1.35rem; font-weight:700; letter-spacing:0.02em; }
  .logo-tagline { font-size:0.95rem; font-style:italic; margin-top:8px; font-family:'Inter',sans-serif; letter-spacing:normal; }

  .nav { padding:12px 0; flex:1; overflow-y:auto; scrollbar-width:none; }
  .nav::-webkit-scrollbar { display:none; }

  /* Light flame animation */
  @keyframes diya-flame-light {
    0%,100% { text-shadow:0 1px 2px rgba(0,0,0,0.12), 0 0 10px rgba(190,110,8,0.52), 0 0 22px rgba(170,90,5,0.24); }
    40%      { text-shadow:0 1px 2px rgba(0,0,0,0.12), 0 0 18px rgba(210,130,10,0.75), 0 0 38px rgba(180,100,5,0.35); }
    70%      { text-shadow:0 1px 2px rgba(0,0,0,0.12), 0 0 12px rgba(195,115,8,0.6),  0 0 26px rgba(170,90,5,0.26); }
  }
  @keyframes icon-flame-light {
    0%,100% { filter:saturate(1.2) brightness(1.0) drop-shadow(0 0 3px rgba(200,120,10,0.52)); }
    50%      { filter:saturate(1.4) brightness(1.08) drop-shadow(0 0 8px rgba(220,140,15,0.82)) drop-shadow(0 0 15px rgba(185,100,5,0.35)); }
  }
  /* Dark flame animation */
  @keyframes diya-flame-dark {
    0%,100% { text-shadow:0 0 10px rgba(245,200,60,0.6),  0 0 22px rgba(220,150,20,0.3),  0 0 40px rgba(200,120,10,0.15); }
    40%      { text-shadow:0 0 18px rgba(255,215,70,0.95), 0 0 38px rgba(235,170,30,0.55), 0 0 60px rgba(210,130,15,0.25); }
    70%      { text-shadow:0 0 12px rgba(245,200,55,0.75), 0 0 26px rgba(225,155,25,0.38), 0 0 45px rgba(200,120,10,0.18); }
  }
  @keyframes icon-flame-dark {
    0%,100% { filter:brightness(1.1) saturate(1.3) drop-shadow(0 0 4px rgba(245,200,60,0.55)); }
    50%      { filter:brightness(1.2) saturate(1.5) drop-shadow(0 0 10px rgba(255,215,70,0.9)) drop-shadow(0 0 18px rgba(220,150,20,0.4)); }
  }

  .nav-section-label { font-family:'Inter',sans-serif; font-size:0.85rem; letter-spacing:0.08em; text-transform:uppercase; padding:18px 26px 6px; user-select:none; font-weight:700; }
  .nav-item { display:flex; align-items:center; gap:14px; padding:12px 22px; margin:2px 10px; border-radius:10px; cursor:pointer; transition:all 0.28s cubic-bezier(.4,0,.2,1); border-left:4px solid transparent; font-size:1rem; font-weight:500; font-family:'Inter',sans-serif; letter-spacing:normal; line-height:1.3; }
  .nav-icon { font-size:1.2rem; width:22px; text-align:center; flex-shrink:0; transition:filter 0.28s, opacity 0.28s; }
  .sidebar-divider { height:1px; margin:8px 20px; }
  .sidebar-footer { padding:16px 20px 12px; font-size:0.9rem; text-align:center; font-family:'Inter',sans-serif; letter-spacing:normal; line-height:1.7; }

  /* Theme toggle button */
  .sb-theme-toggle { display:flex; align-items:center; justify-content:center; gap:8px; margin:0 18px 16px; padding:9px 16px; border-radius:22px; cursor:pointer; font-family:'Inter',sans-serif; font-size:0.9rem; font-weight:600; letter-spacing:normal; transition:all 0.22s; user-select:none; }


  /* Main */
  .main { margin-left:268px; flex:1; display:flex; flex-direction:column; min-height:100vh; }
  .topbar { padding:16px 32px; border-bottom:2px solid; border-image:linear-gradient(90deg,rgba(232,131,42,0.3),rgba(255,208,96,0.6),rgba(201,149,58,0.3)) 1; display:flex; align-items:center; justify-content:space-between; background:rgba(255,255,255,0.97); backdrop-filter:blur(12px); position:sticky; top:0; z-index:50; }
  .topbar-title { font-family:'Inter',sans-serif; font-weight:700; font-size:1.3rem; color:var(--saffron); text-shadow:none; }
  .user-pill { display:flex; align-items:center; gap:8px; background:#FFFFFF; border:1px solid rgba(201,149,58,0.4); border-radius:24px; padding:6px 14px; font-size:0.88rem; cursor:pointer; transition:all 0.2s; color:#7A3500; box-shadow:0 2px 8px rgba(201,149,58,0.1); }
  .user-pill:hover { border-color:var(--saffron); box-shadow:0 3px 16px rgba(232,131,42,0.25); }
  .avatar { width:28px; height:28px; background:linear-gradient(135deg,var(--saffron),var(--gold)); border-radius:50%; display:flex; align-items:center; justify-content:center; font-size:0.8rem; color:white; font-weight:600; }
  .page { padding:32px; max-width:900px; }
  .section-title { font-family:'Inter',sans-serif; font-weight:700; font-size:1.8rem; color:var(--saffron); margin-bottom:8px; text-shadow:none; }
  .section-sub { font-size:1.15rem; color:var(--text-dim); font-style:italic; margin-bottom:28px; }

  /* Shloka card */
  .shloka-card {
    background: #FFFFFF;
    border: 1px solid rgba(201,149,58,0.25);
    border-top: 3px solid;
    border-image: linear-gradient(90deg, #E8832A, #FFD060, #C9953A) 1;
    border-radius: var(--radius); padding:36px; margin-bottom:24px; position:relative; overflow:hidden;
    box-shadow: 0 4px 24px rgba(201,149,58,0.1), 0 1px 4px rgba(201,149,58,0.08);
  }
  .shloka-card::before { content:'ॐ'; font-family:'Noto Sans Devanagari',serif; position:absolute; top:-20px; right:20px; font-size:9rem; color:rgba(201,149,58,0.12); line-height:1; pointer-events:none; }
  .shloka-badge { display:inline-flex; align-items:center; gap:6px; background:rgba(232,131,42,0.12); border:1px solid rgba(232,131,42,0.4); border-radius:20px; padding:5px 14px; font-size:0.9rem; font-weight:600; color:var(--saffron); margin-bottom:20px; }
  .shloka-ref { font-family:'Inter',sans-serif; font-size:1rem; color:#a16207; margin-bottom:16px; font-weight:700; }
  .shloka-sanskrit { font-family:'Noto Sans Devanagari',serif; font-size:1.7rem; color:var(--saffron); line-height:2.2; margin-bottom:12px; text-shadow:0 0 30px rgba(232,131,42,0.25); letter-spacing:0.02em; }
  .shloka-translit { font-style:italic; font-size:1.15rem; color:var(--text-dim); margin-bottom:20px; line-height:1.85; }
  .divider-line { display:flex; align-items:center; gap:12px; margin:22px 0; }
  .divider-line::before,.divider-line::after { content:''; flex:1; height:1px; background:linear-gradient(90deg,transparent,rgba(201,149,58,0.5),transparent); }
  .divider-diamond { width:8px; height:8px; background:linear-gradient(135deg,var(--saffron),var(--gold)); transform:rotate(45deg); box-shadow:0 0 10px rgba(232,131,42,0.6); }
  .shloka-meaning { font-size:1.55rem; line-height:2.1; color:var(--text); margin-bottom:28px; font-weight:400; }
  .share-row { display:flex; gap:10px; flex-wrap:wrap; }
  .share-btn { display:flex; align-items:center; gap:6px; padding:9px 18px; border-radius:8px; border:1px solid var(--border); background:transparent; color:var(--text-dim); font-family:'Inter',sans-serif; font-size:0.95rem; cursor:pointer; transition:all 0.2s; }
  .share-btn:hover { border-color:var(--saffron); color:var(--saffron); background:var(--glow); }
  .share-btn.whatsapp:hover { border-color:#25D366; color:#25D366; }
  .share-btn.instagram:hover { border-color:#E1306C; color:#E1306C; }

  /* Chat */
  .chat-container { display:flex; flex-direction:column; height:calc(100vh - 200px); }
  .chat-messages { flex:1; overflow-y:auto; padding:24px 0; display:flex; flex-direction:column; gap:28px; scrollbar-width:thin; scrollbar-color:var(--border) transparent; }
  .msg { display:flex; gap:14px; animation:fadein 0.35s ease; }
  @keyframes fadein { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:none} }
  .msg-user { flex-direction:row-reverse; }
  .msg-avatar { width:38px; height:38px; border-radius:50%; flex-shrink:0; display:flex; align-items:center; justify-content:center; font-size:1.1rem; }
  .msg-avatar.user { background:linear-gradient(135deg,var(--saffron),var(--gold)); }
  .msg-avatar.ai { background:var(--bg3); border:1px solid rgba(201,149,58,0.3); font-family:'Noto Sans Devanagari',serif; color:var(--saffron); box-shadow:0 0 12px rgba(201,149,58,0.1); }
  .msg-bubble { max-width:75%; min-width:80px; padding:16px 22px; border-radius:var(--radius); font-size:1.22rem; line-height:1.8; word-break:break-word; }
  .msg-user .msg-bubble { background:linear-gradient(135deg,var(--saffron),var(--gold)); border:none; color:#fff; border-radius:var(--radius) 4px var(--radius) var(--radius); }
  .msg-ai .msg-bubble { background:#FFFFFF; border:1px solid rgba(201,149,58,0.22); border-left:3px solid var(--gold); color:var(--text); border-radius:4px var(--radius) var(--radius) var(--radius); box-shadow:0 2px 12px rgba(201,149,58,0.08); }
  .emotion-tag { display:inline-block; font-size:0.72rem; color:var(--text-dim); margin-bottom:6px; letter-spacing:0.06em; }
  .chat-input-row { display:flex; gap:10px; padding:16px 0 0; border-top:1px solid var(--border); }
  .chat-input { flex:1; background:var(--bg2); border:1px solid var(--border); border-radius:var(--radius); padding:14px 18px; color:var(--text); font-family:'Crimson Pro',serif; font-size:1.15rem; outline:none; transition:border-color 0.2s; }
  .chat-input:focus { border-color:var(--saffron); }
  .chat-input::placeholder { color:var(--text-dim); }
  .send-btn { background:linear-gradient(135deg,var(--saffron),var(--gold)); border:none; border-radius:var(--radius); padding:14px 22px; color:white; font-family:'Crimson Pro',serif; font-size:1rem; cursor:pointer; transition:opacity 0.2s; white-space:nowrap; }
  .send-btn:hover { opacity:0.88; }
  .send-btn:disabled { opacity:0.4; cursor:not-allowed; }

  /* Journal */
  .journal-list { display:flex; flex-direction:column; gap:16px; margin-top:8px; }
  .journal-entry { background:#FFFFFF; border:1px solid rgba(201,149,58,0.2); border-left:3px solid var(--gold); border-radius:var(--radius); padding:20px 24px; transition:all 0.2s; box-shadow:0 2px 10px rgba(201,149,58,0.07); }
  .journal-entry:hover { box-shadow:0 4px 20px rgba(201,149,58,0.15); border-left-color:var(--saffron); }
  .journal-date { font-size:0.85rem; color:var(--text-dim); letter-spacing:0.08em; text-transform:uppercase; margin-bottom:8px; }
  .journal-text { font-size:1.15rem; line-height:1.85; color:var(--text); }
  .journal-verse { margin-top:10px; font-size:0.95rem; color:var(--saffron); font-style:italic; }
  .journal-new { width:100%; background:var(--bg2); border:1px solid var(--border); border-radius:var(--radius); padding:16px 18px; color:var(--text); font-family:'Crimson Pro',serif; font-size:1rem; line-height:1.7; outline:none; resize:vertical; min-height:100px; margin-bottom:12px; transition:border-color 0.2s; }
  .journal-new:focus { border-color:var(--saffron); }

  /* Profile */
  .profile-card { background:#FFFFFF; border:1px solid rgba(201,149,58,0.22); border-top:3px solid; border-image:linear-gradient(90deg,#E8832A,#FFD060,#C9953A) 1; border-radius:var(--radius); padding:28px 32px; margin-bottom:20px; box-shadow:0 4px 24px rgba(201,149,58,0.1); }
  .profile-avatar-lg { width:72px; height:72px; background:linear-gradient(135deg,var(--saffron),var(--gold)); border-radius:50%; display:flex; align-items:center; justify-content:center; font-size:2rem; color:white; font-weight:700; margin-bottom:16px; }
  .profile-name { font-family:'Inter',sans-serif; font-weight:700; font-size:1.5rem; color:var(--saffron); margin-bottom:6px; text-shadow:none; }
  .profile-since { font-size:0.95rem; color:var(--text-dim); font-style:italic; }
  .stats-row { display:flex; gap:16px; margin-top:20px; flex-wrap:wrap; }
  .stat-box { background:#FFFFFF; border:1px solid rgba(201,149,58,0.25); border-bottom:2px solid var(--gold); border-radius:8px; padding:16px 20px; text-align:center; min-width:110px; box-shadow:0 2px 10px rgba(201,149,58,0.1); }
  .stat-num { font-family:'Inter',sans-serif; font-weight:700; font-size:1.8rem; color:var(--saffron); text-shadow:none; }
  .stat-label { font-size:0.95rem; color:var(--text-dim); margin-top:4px; letter-spacing:0.02em; }

  .btn { background:linear-gradient(135deg,var(--saffron),var(--gold)); border:none; border-radius:8px; padding:10px 22px; color:white; font-family:'Inter',sans-serif; font-weight:600; font-size:0.95rem; cursor:pointer; transition:opacity 0.2s; }
  .btn:hover { opacity:0.88; }
  .btn-outline { background:transparent; border:1px solid var(--border); color:var(--text-dim); }
  .btn-outline:hover { border-color:var(--saffron); color:var(--saffron); background:var(--glow); }

  /* Login */
  .login-page { min-height:100vh; display:flex; align-items:center; justify-content:center; background:var(--bg); }
  .login-card { background:#FFFFFF; border:1px solid rgba(201,149,58,0.3); border-top:3px solid; border-image:linear-gradient(90deg,#E8832A,#FFD060,#C9953A) 1; border-radius:var(--radius); padding:48px 40px; width:380px; text-align:center; box-shadow:0 8px 48px rgba(201,149,58,0.15); }
  .login-om { font-family:'Noto Sans Devanagari',serif; font-size:4rem; color:var(--saffron); display:block; margin-bottom:12px; filter:drop-shadow(0 0 16px rgba(232,131,42,0.6)); animation:pulse-om 3s ease-in-out infinite; }
  .login-title { font-family:'Inter',sans-serif; font-weight:700; font-size:1.6rem; color:var(--saffron); margin-bottom:6px; }
  .login-sub { font-size:0.98rem; color:var(--text-dim); font-style:italic; margin-bottom:32px; }
  .input-field { width:100%; background:#FAFAFA; border:1px solid rgba(201,149,58,0.3); border-radius:8px; padding:12px 16px; color:var(--text); font-family:'Inter',sans-serif; font-size:1.05rem; outline:none; margin-bottom:14px; transition:border-color 0.2s; text-align:left; }
  .input-field:focus { border-color:var(--saffron); }
  .input-field::placeholder { color:var(--text-dim); opacity:0.9; }
  .login-btn { width:100%; background:linear-gradient(135deg,var(--saffron),var(--gold)); border:none; border-radius:8px; padding:13px; color:white; font-family:'Inter',sans-serif; font-weight:700; font-size:1rem; cursor:pointer; letter-spacing:normal; transition:opacity 0.2s; margin-top:4px; }
  .login-btn:hover { opacity:0.88; }
  .login-btn:disabled { opacity:0.5; cursor:not-allowed; }
  .login-switch { font-size:0.95rem; color:var(--text-dim); margin-top:16px; }
  .login-switch span { color:var(--saffron); cursor:pointer; }
  .login-switch span:hover { text-decoration:underline; }
  .error-msg { background:rgba(220,50,50,0.08); border:1px solid rgba(220,50,50,0.3); border-radius:8px; padding:10px 14px; font-size:0.95rem; color:#b91c1c; margin-bottom:14px; text-align:left; }
  .success-msg { background:rgba(50,200,100,0.08); border:1px solid rgba(50,200,100,0.3); border-radius:8px; padding:10px 14px; font-size:0.95rem; color:#15803d; margin-bottom:14px; text-align:left; }
  .divider-or { display:flex; align-items:center; gap:12px; margin:16px 0; color:var(--text-dim); font-size:0.95rem; }
  .divider-or::before,.divider-or::after { content:''; flex:1; height:1px; background:var(--border); }
  .google-btn { width:100%; background:white; border:1px solid #ddd; border-radius:8px; padding:12px; color:#333; font-family:'Inter',sans-serif; font-size:1rem; cursor:pointer; transition:all 0.2s; display:flex; align-items:center; justify-content:center; gap:10px; margin-bottom:4px; }
  .google-btn:hover { border-color:var(--saffron); box-shadow:0 0 0 2px var(--glow); }

  /* Loading */
  .loading-screen { min-height:100vh; display:flex; align-items:center; justify-content:center; background:var(--bg); flex-direction:column; gap:16px; }
  .loading-om { font-family:'Noto Sans Devanagari',serif; font-size:5rem; color:var(--saffron); animation:pulse-om 2s ease-in-out infinite; }

  /* Global text quality boost — applies across all pages */
  .page h1,.page h2,.page h3 { font-family:'Cinzel Decorative',serif; color:var(--saffron); line-height:1.3; }
  .page p { font-size:1.1rem; line-height:1.9; color:var(--text); }
  .page label { font-size:1rem; color:var(--text-dim); font-weight:500; letter-spacing:0.03em; }

  ::-webkit-scrollbar { width:4px; }
  ::-webkit-scrollbar-track { background:transparent; }
  ::-webkit-scrollbar-thumb { background:var(--border); border-radius:4px; }
  @keyframes shimmer { 0%{background-position:200% 0} 100%{background-position:-200% 0} }
  @keyframes bell-ring {
    0%{transform:rotate(0deg)} 8%{transform:rotate(18deg)} 16%{transform:rotate(-16deg)}
    24%{transform:rotate(12deg)} 32%{transform:rotate(-10deg)} 40%{transform:rotate(6deg)}
    48%{transform:rotate(-4deg)} 56%{transform:rotate(2deg)} 64%{transform:rotate(-1deg)}
    100%{transform:rotate(0deg)}
  }
  @keyframes sacred-appear {
    from{opacity:0;transform:scale(0.92) translateY(8px)} to{opacity:1;transform:scale(1) translateY(0)}
  }
  @keyframes star-twinkle {
    0%,100%{opacity:0.5;transform:scale(1)} 50%{opacity:1;transform:scale(1.4)}
  }
  @keyframes flame-breathe {
    0%,100%{opacity:0.6;transform:translateX(-50%) scaleY(1) scaleX(1)}
    50%{opacity:1;transform:translateX(-50%) scaleY(1.1) scaleX(0.85)}
  }
  @keyframes glow-pulse {
    0%,100%{opacity:0.7} 50%{opacity:1}
  }
  @keyframes lamp-sway {
    0%,100%{transform:translateX(-50%) rotate(-1.8deg)} 50%{transform:translateX(-50%) rotate(1.8deg)}
  }
  @keyframes smoke-drift {
    0%{opacity:0.07;transform:translateX(-50%) scaleX(1) translateY(0)}
    50%{opacity:0.04;transform:translateX(-50%) scaleX(1.4) translateY(-22px)}
    100%{opacity:0;transform:translateX(-50%) scaleX(0.6) translateY(-55px)}
  }
  @keyframes petal-drift {
    0%{transform:translateY(0) rotate(0deg);opacity:0.7}
    100%{transform:translateY(60px) rotate(140deg);opacity:0}
  }
  /* Chat page — make main fill viewport so flex children can divide space */
  .main.chat-page { height: 100vh; overflow: hidden; display: flex; flex-direction: column; }
  .chat-layout {
    display: flex;
    flex: 1;
    min-height: 0;
    overflow: hidden;
    width: 100%;
  }
  .chat-sidebar {
    width: 260px;
    min-width: 260px;
    flex-shrink: 0;
    background: linear-gradient(180deg, #FFF6E6, #FFEFD6);
    border-right: 2px solid rgba(201,149,58,0.28);
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .chat-sidebar-header {
    padding: 16px;
    border-bottom: 2px solid;
    border-image: linear-gradient(90deg,#E8832A,#FFD060,#C9953A) 1;
    background: rgba(255,255,255,0.6);
  }
  .new-chat-btn {
    width: 100%;
    background: linear-gradient(135deg, var(--saffron), var(--gold));
    border: none;
    border-radius: 10px;
    padding: 11px 16px;
    color: #fff;
    font-family: 'Cinzel Decorative', serif;
    font-size: 0.82rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.2s;
    letter-spacing: 0.04em;
    box-shadow: 0 3px 12px rgba(232,131,42,0.3);
  }
  .new-chat-btn:hover { opacity: 0.9; transform: translateY(-1px); }
  .sessions-list {
    flex: 1;
    overflow-y: auto;
    padding: 10px 8px;
    scrollbar-width: thin;
    scrollbar-color: var(--border) transparent;
  }
  .session-group-label {
    font-size: 0.72rem;
    color: var(--saffron);
    letter-spacing: 0.12em;
    text-transform: uppercase;
    padding: 12px 10px 5px;
    font-family: 'Cinzel Decorative', serif;
    font-weight: 400;
  }
  .session-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.15s;
    margin-bottom: 3px;
    border: 1px solid transparent;
  }
  .session-item:hover { background: rgba(232,131,42,0.1); border-color: rgba(232,131,42,0.2); }
  .session-item.active {
    background: rgba(232,131,42,0.15);
    border: 1px solid rgba(232,131,42,0.35);
    box-shadow: 0 2px 8px rgba(232,131,42,0.1);
  }
  .session-title {
    flex: 1;
    font-size: 0.92rem;
    color: var(--text);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: 'Crimson Pro', serif;
  }
  .session-item.active .session-title { color: var(--saffron); font-weight: 600; }
  .session-item:hover .session-title { color: var(--text); }
  .session-delete {
    opacity: 0;
    background: none;
    border: none;
    color: var(--text-dim);
    cursor: pointer;
    font-size: 0.8rem;
    padding: 2px 4px;
    border-radius: 4px;
    transition: all 0.15s;
  }
  .session-item:hover .session-delete { opacity: 1; }
  .session-delete:hover { color: #ff6b6b; background: rgba(255,107,107,0.1); }
  .chat-main {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    min-width: 0;
    background: var(--bg);
  }
  .chat-main-header {
    padding: 18px 32px 14px;
    border-bottom: 2px solid;
    border-image: linear-gradient(90deg,#E8832A,#FFD060,#C9953A) 1;
    background: rgba(255,255,255,0.97);
    backdrop-filter: blur(8px);
  }
  .chat-messages {
    flex: 1;
    overflow-y: auto;
    padding: 28px 36px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    scrollbar-width: thin;
    scrollbar-color: var(--border) transparent;
  }
  .msg { display: flex; gap: 14px; animation: fadein 0.3s ease; }
  .msg-user { flex-direction: row-reverse; }
  .msg-avatar {
    width: 40px; height: 40px; border-radius: 50%; flex-shrink: 0;
    display: flex; align-items: center; justify-content: center;
    font-weight: 600;
  }
  .msg-avatar.user {
    background: linear-gradient(135deg, var(--saffron), var(--gold));
    color: white; font-size: 1rem;
  }
  .msg-avatar.ai {
    background: #FFFFFF;
    border: 1.5px solid rgba(201,149,58,0.4);
    font-family: 'Noto Sans Devanagari', serif;
    color: var(--saffron); font-size: 1.3rem;
    box-shadow: 0 2px 8px rgba(201,149,58,0.1);
  }
  .msg-content { display: flex; flex-direction: column; gap: 6px; max-width: 80%; }
  .msg-user .msg-content { align-items: flex-end; }
  .msg-emotion {
    font-size: 0.8rem; color: var(--text-dim);
    letter-spacing: 0.06em; padding: 0 4px;
  }
  .msg-bubble {
    padding: 16px 22px;
    border-radius: 16px;
    font-size: 1.22rem;
    line-height: 1.8;
    min-width: 80px;
    word-break: break-word;
  }
  .msg-user .msg-bubble {
    background: linear-gradient(135deg, var(--saffron), var(--gold));
    border: none;
    color: #ffffff;
    border-radius: 16px 4px 16px 16px;
    font-weight: 500;
    box-shadow: 0 4px 16px rgba(232,131,42,0.3);
  }
  .msg-ai .msg-bubble {
    background: #FFFFFF;
    border: 1px solid rgba(201,149,58,0.25);
    border-left: 3px solid var(--gold);
    color: var(--text);
    border-radius: 4px 16px 16px 16px;
    box-shadow: 0 2px 12px rgba(201,149,58,0.08);
  }
  .msg-time { font-size: 0.75rem; color: var(--text-dim); padding: 0 4px; }
  .typing-indicator {
    display: flex; gap: 5px; align-items: center;
    padding: 16px 22px;
    background: #FFFFFF;
    border: 1px solid rgba(201,149,58,0.25);
    border-left: 3px solid var(--gold);
    border-radius: 4px 16px 16px 16px;
    width: fit-content;
    box-shadow: 0 2px 12px rgba(201,149,58,0.08);
  }
  .typing-dot {
    width: 7px; height: 7px; border-radius: 50%;
    background: var(--saffron); opacity: 0.5;
    animation: typing-bounce 1.2s ease-in-out infinite;
  }
  .typing-dot:nth-child(2) { animation-delay: 0.2s; }
  .typing-dot:nth-child(3) { animation-delay: 0.4s; }
  @keyframes typing-bounce {
    0%,60%,100% { transform: translateY(0); opacity: 0.5; }
    30% { transform: translateY(-8px); opacity: 1; }
  }
  .chat-input-area {
    padding: 12px 14px 12px 20px;
    background: linear-gradient(145deg, #FFFBF0, #FFF8EC);
    border: 2px solid rgba(201,149,58,0.38);
    border-radius: 22px;
    margin: 0 12px 12px;
    position: sticky;
    bottom: 0;
    z-index: 10;
    box-shadow: 0 4px 24px rgba(201,149,58,0.18);
    transition: border-color 0.3s, box-shadow 0.3s;
    display: flex;
    align-items: flex-end;
    gap: 10px;
  }
  .chat-input-area:focus-within {
    border-color: rgba(232,131,42,0.75);
    box-shadow: 0 4px 32px rgba(232,131,42,0.22);
  }
  .chat-input-row {
    flex: 1;
    display: flex; align-items: flex-end;
    background: transparent;
    border: none;
    padding: 0;
    box-shadow: none;
  }
  .chat-input {
    flex: 1; background: transparent; border: none;
    color: #3A1A00; font-family: 'Crimson Pro', serif;
    font-size: 1.18rem; outline: none; resize: none;
    max-height: 120px; min-height: 32px; line-height: 1.7;
    padding: 4px 0;
  }
  .chat-input::placeholder {
    color: #C9953A;
    opacity: 1;
    font-style: italic;
    text-shadow: 0 0 10px rgba(201,149,58,0.35);
  }
  .send-btn {
    background: linear-gradient(135deg, #E8832A, #C9953A);
    border: none; border-radius: 16px;
    width: 46px; height: 46px; flex-shrink: 0;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer; transition: all 0.25s; font-size: 1.25rem;
    box-shadow: 0 3px 12px rgba(232,131,42,0.4);
  }
  .send-btn:hover { transform: scale(1.06); box-shadow: 0 5px 20px rgba(232,131,42,0.5); }
  .send-btn:disabled { opacity: 0.3; cursor: not-allowed; transform: none; box-shadow: none; }
  .quick-prompts {
    display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 14px;
  }
  .quick-prompt {
    background: rgba(232,131,42,0.07); border: 1px solid rgba(232,131,42,0.2);
    border-radius: 20px; padding: 8px 18px;
    font-size: 0.92rem; color: var(--text);
    cursor: pointer; transition: all 0.2s;
    font-family: 'Crimson Pro', serif;
  }
  .quick-prompt:hover { background: rgba(232,131,42,0.14); border-color: var(--saffron); color: var(--saffron); }
  .empty-chat {
    flex: 1; display: flex; flex-direction: column;
    align-items: center; justify-content: center;
    color: var(--text-dim); text-align: center; padding: 40px;
  }
  .empty-om {
    font-family: 'Noto Sans Devanagari', serif;
    font-size: 5rem; color: var(--saffron); opacity: 0.35;
    margin-bottom: 20px;
    filter: drop-shadow(0 0 24px rgba(232,131,42,0.35));
  }
  .empty-title {
    font-family: 'Cinzel Decorative', serif;
    font-size: 1.4rem; color: var(--text);
    margin-bottom: 10px;
  }
  .empty-sub { font-size: 1.05rem; color: var(--text-dim); font-style: italic; }

  /* ── MOBILE LAYOUT ─────────────────────────────────────────────────────── */
  @media (max-width: 767px) {
    /* rem scales from html — set html font-size so all rem values scale automatically */
    html { font-size: 17px !important; }
    body { font-size: 17px !important; }
    /* Force 2-col puja grids to single column on mobile */
    .puja-col-2 { grid-template-columns: 1fr !important; }
    /* Prevent horizontal overflow everywhere on mobile */
    .page { overflow-x: hidden; }
    .main { overflow-x: hidden; }
    /* Muhurta activity: 4-col → 2-col on mobile */
    .muhurta-activity-grid { grid-template-columns: repeat(2,1fr) !important; }

    /* Hide desktop sidebar */
    .sidebar { display: none !important; }

    /* Main fills full screen, add bottom padding for tab bar */
    .main { margin-left: 0 !important; padding-bottom: 68px; }

    /* Topbar adjustments */
    .topbar { padding: 12px 16px !important; }
    .topbar-title { font-size: 0.9rem !important; }

    /* Page padding reduced */
    .page { padding: 16px !important; }

    /* Bottom tab bar */
    .bottom-nav {
      display: flex !important;
      position: fixed; bottom: 0; left: 0; right: 0; z-index: 200;
      background: linear-gradient(180deg, rgba(255,232,138,0.97), rgba(255,248,216,0.99));
      border-top: 2px solid transparent;
      border-image: linear-gradient(90deg,#E8832A,#FFD060,#C9953A) 1;
      backdrop-filter: blur(16px);
      height: 68px;
      padding: 0 4px;
      padding-bottom: env(safe-area-inset-bottom, 0px);
    }
    .bottom-nav-item {
      flex: 1; display: flex; flex-direction: column; align-items: center;
      justify-content: center; gap: 2px; cursor: pointer;
      color: #5A2D00; transition: all 0.2s; padding: 4px 0;
      font-size: 13px; letter-spacing: 0.02em; text-transform: uppercase;
      font-weight: 700;
      border: none; background: none;
      -webkit-tap-highlight-color: transparent;
    }
    .bottom-nav-item.active { color: var(--saffron); }
    .bottom-nav-item .nav-tab-icon { font-size: 26px; line-height: 1; }
    .bottom-nav-item .nav-tab-streak {
      position: absolute; top: 4px; right: calc(50% - 22px);
      background: linear-gradient(135deg,#ff6b2b,#ff4500);
      color: white; border-radius: 8px;
      padding: 1px 5px; font-size: 0.6rem; font-weight: 700;
    }

    /* Chat layout on mobile */
    .chat-layout { flex-direction: column; }
    .chat-sidebar { display: none !important; }
    .chat-main { min-height: 0; flex: 1; }
    .chat-main-header { padding: 12px 16px 10px !important; }
    .chat-main-header .section-title { font-size: 1rem !important; }
    .chat-messages { padding: 16px 12px 8px !important; gap: 16px !important; }
    .chat-messages { padding: 16px 16px 8px !important; gap: 20px !important; }
    .chat-input-area { padding: 8px 12px 12px !important; }
    .msg-bubble { font-size: 1rem !important; line-height: 1.7 !important; padding: 13px 18px !important; min-width: 80px !important; }
    .msg-content { max-width: 90% !important; }

    /* Shloka card on mobile */
    .shloka-card { padding: 20px !important; }
    .shloka-sanskrit { font-size: 1.15rem !important; }
    .shloka-meaning { font-size: 1.05rem !important; }
    .share-row { gap: 8px !important; }
    .share-btn { padding: 8px 12px !important; font-size: 0.85rem !important; }

    /* Profile stats row */
    .stats-row { gap: 10px !important; }
    .stat-box { min-width: 80px !important; padding: 12px !important; }
    .stat-num { font-size: 1.3rem !important; }

    /* Journey page adjustments */
    .section-title { font-size: 1.2rem !important; }
    .section-sub { font-size: 1rem !important; }
  }

  /* Hide bottom nav on desktop */
  .bottom-nav { display: none; }


  @media (max-width: 767px) {
    .mobile-om { display: inline !important; }
    .user-pill-name { display: none; }
    .user-pill { padding: 6px 10px !important; }
  }

  /* ── Mobile drawer overlay ── */
  .mob-overlay {
    display: none;
    position: fixed; inset: 0; z-index: 498;
    background: rgba(0,0,0,0.5);
    opacity: 0; pointer-events: none;
    transition: opacity 0.28s;
  }
  .mob-overlay.open { opacity: 1; pointer-events: all; }

  /* ── Mobile slide-in nav drawer ── */
  .mob-drawer {
    display: none;
    position: fixed; top: 0; left: 0; bottom: 0; width: 280px; z-index: 499;
    flex-direction: column;
    transform: translateX(-100%);
    transition: transform 0.3s cubic-bezier(.4,0,.2,1);
    overflow-y: auto;
    overflow-x: hidden;
  }
  .mob-drawer.open { transform: translateX(0); }

  .mob-drawer-close {
    position: absolute; top: 14px; right: 14px; z-index: 10;
    width: 34px; height: 34px; border-radius: 50%; border: none; cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    font-size: 1.1rem; line-height: 1;
    background: rgba(0,0,0,0.12);
    color: inherit;
    transition: background 0.2s;
  }
  .mob-drawer-close:hover { background: rgba(0,0,0,0.22); }

  @media (max-width: 767px) {
    .mob-overlay { display: block; }
    .mob-drawer  { display: flex; }
  }

  /* Sidebar overlay visible on narrow desktop/tablet */
  @media (max-width: 1023px) {
    .sidebar-backdrop { display: block !important; }
    .main { margin-left: 0 !important; }
  }
`;

let styleEl = document.getElementById("vs-styles");
if (!styleEl) {
  styleEl = document.createElement("style");
  styleEl.id = "vs-styles";
  document.head.appendChild(styleEl);
}
styleEl.textContent = css;




const MOCK_JOURNAL = [
  { id:1, date:"March 19, 2026", text:"Today I understood nishkama karma. Performing duties without expecting results brings such peace.", verse:"BG 2.47 — Do your duty without attachment" },
  { id:2, date:"March 18, 2026", text:"Meditating on the eternal soul. Death is not the end.", verse:"BG 2.20 — The soul is never born nor dies" },
];

// ══════════════════════════════════════════════════════════════════════════════
// LOGIN PAGE — Real Supabase Auth
// ══════════════════════════════════════════════════════════════════════════════

// ── Dev-only login (npm start only — never in production builds) ─────────────
// Signs in as a fixed local user without Supabase, so signed-in pages can be
// tested locally when auth is unavailable. Persisted so reloads stay signed in.
const IS_DEV = process.env.NODE_ENV === "development";
const DEV_USER = { id: "dev-local-user", name: "Dev User", email: "dev@localhost", photo: "" };
function getDevUser() {
  if (!IS_DEV) return null;
  try { return localStorage.getItem("vs_dev_login") ? DEV_USER : null; } catch { return null; }
}

function LoginPage({ onLogin }) {
  const [mode, setMode]         = useState("login");
  const [name, setName]         = useState("");
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState("");
  const [success, setSuccess]   = useState("");

  const handleSubmit = async () => {
    if (!email || !password) { setError("Please enter email and password"); return; }
    if (password.length < 6)  { setError("Password must be at least 6 characters"); return; }
    setLoading(true); setError(""); setSuccess("");

    try {
      if (mode === "login") {
        const { data, error } = await supabase.auth.signInWithPassword({ email, password });
        if (error) { setError(error.message); return; }
        const m = data.user.user_metadata || {};
        onLogin({
          name:  m.full_name || m.name || email.split("@")[0],
          email: data.user.email,
          id:    data.user.id,
          photo: m.avatar_url || m.picture || "",
        });
      } else {
        const { data, error } = await supabase.auth.signUp({
          email, password,
          options: { data: { name: name || email.split("@")[0] } }
        });
        if (error) { setError(error.message); return; }
        if (data.user && !data.session) {
          setSuccess("✅ Check your email to confirm your account, then sign in!");
          setMode("login");
        } else if (data.user) {
          onLogin({ name: name || email.split("@")[0], email: data.user.email, id: data.user.id, photo: "" });
        }
      }
    } catch { setError("Something went wrong. Please try again."); }
    finally  { setLoading(false); }
  };

  const handleGoogle = async () => {
    setLoading(true);
    const { error } = await supabase.auth.signInWithOAuth({
      provider:"google",
      options: { redirectTo: window.location.origin }
    });
    if (error) { setError(error.message); setLoading(false); }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <span className="login-om">ॐ</span>
        <div className="login-title">Vedsanga</div>
        <div className="login-sub">वेदसङ्ग • Your divine companion</div>

        {error   && <div className="error-msg">⚠️ {error}</div>}
        {success && <div className="success-msg">{success}</div>}

        {mode === "register" && (
          <input className="input-field" placeholder="Your name"
            value={name} onChange={e => setName(e.target.value)} />
        )}
        <input className="input-field" placeholder="Email" type="email"
          value={email} onChange={e => { setEmail(e.target.value); setError(""); }} />
        <input className="input-field" placeholder="Password (min 6 characters)" type="password"
          value={password}
          onChange={e => { setPassword(e.target.value); setError(""); }}
          onKeyDown={e => e.key === "Enter" && handleSubmit()} />

        <button className="login-btn" onClick={handleSubmit} disabled={loading}>
          {loading ? "Please wait..." : mode === "login" ? "Enter the Sacred Space" : "Begin Your Journey"}
        </button>

        <div className="divider-or">or</div>

        <button className="google-btn" onClick={handleGoogle} disabled={loading}>
          <svg width="18" height="18" viewBox="0 0 18 18">
            <path fill="#4285F4" d="M16.51 8H8.98v3h4.3c-.18 1-.74 1.48-1.6 2.04v2.01h2.6a7.8 7.8 0 002.38-5.88c0-.57-.05-.66-.15-1.18z"/>
            <path fill="#34A853" d="M8.98 17c2.16 0 3.97-.72 5.3-1.94l-2.6-2a4.8 4.8 0 01-7.18-2.54H1.83v2.07A8 8 0 008.98 17z"/>
            <path fill="#FBBC05" d="M4.5 10.52a4.8 4.8 0 010-3.04V5.41H1.83a8 8 0 000 7.18l2.67-2.07z"/>
            <path fill="#EA4335" d="M8.98 4.18c1.17 0 2.23.4 3.06 1.2l2.3-2.3A8 8 0 001.83 5.4L4.5 7.49a4.77 4.77 0 014.48-3.31z"/>
          </svg>
          Continue with Google
        </button>

        {IS_DEV && (
          <button className="google-btn" style={{ marginTop: 10 }}
            onClick={() => { localStorage.setItem("vs_dev_login", "1"); onLogin(DEV_USER); }}>
            🛠 Dev login (localhost only)
          </button>
        )}

        <div className="login-switch">
          {mode === "login"
            ? <>New to Vedsanga? <span onClick={() => { setMode("register"); setError(""); }}>Create account</span></>
            : <>Already a seeker? <span onClick={() => { setMode("login"); setError(""); }}>Sign in</span></>}
        </div>
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// DAILY SHLOKA PAGE
// ══════════════════════════════════════════════════════════════════════════════
// ── Replace your ShlokaPage function in App.jsx with this ────────────────────

const MOCK_SHLOKA = {
  chapter: 2, verse: 47,
  sanskrit: "कर्मण्येवाधिकारस्ते मा फलेषु कदाचन |",
  transliteration: "karmaṇyevādhikāraste mā phaleṣu kadācana",
  meaning: "You have a right to perform your prescribed duty, but you are not entitled to the fruits of action. Never consider yourself the cause of the results of your activities, and never be attached to not doing your duty.",
};


const LANG_OPTIONS = [
  { code:"en",    name:"English",    native:"English"   },
  { code:"hi",    name:"Hindi",      native:"हिंदी"      },
  { code:"ta",    name:"Tamil",      native:"தமிழ்"     },
  { code:"te",    name:"Telugu",     native:"తెలుగు"    },
  { code:"kn",    name:"Kannada",    native:"ಕನ್ನಡ"     },
  { code:"ml",    name:"Malayalam",  native:"മലയാളം"    },
  { code:"bn",    name:"Bengali",    native:"বাংলা"     },
  { code:"gu",    name:"Gujarati",   native:"ગુજરાતી"   },
  { code:"mr",    name:"Marathi",    native:"मराठी"     },
  { code:"pa",    name:"Punjabi",    native:"ਪੰਜਾਬੀ"    },
  { code:"es",    name:"Spanish",    native:"Español"   },
  { code:"fr",    name:"French",     native:"Français"  },
  { code:"de",    name:"German",     native:"Deutsch"   },
  { code:"ar",    name:"Arabic",     native:"العربية"   },
  { code:"ja",    name:"Japanese",   native:"日本語"    },
  { code:"zh-CN", name:"Chinese",    native:"中文"      },
  { code:"pt",    name:"Portuguese", native:"Português" },
  { code:"ru",    name:"Russian",    native:"Русский"   },
];

const API = (process.env.REACT_APP_API_URL || "http://localhost:8000").replace(/\/$/, "");

function ShlokaPage({ user, initVerse, initTheme = "", preferredLang = "en" }) {
  const [shloka,          setShloka]          = useState(null);
  const [commentary,      setCommentary]      = useState(null);
  const [cardUrl,         setCardUrl]         = useState(null);
  const [generating,      setGenerating]      = useState(false);
  const [loadingComm,     setLoadingComm]     = useState(false);
  const [verseIdx,        setVerseIdx]        = useState(0);
  const [copied,          setCopied]          = useState(false);
  const [selectedLang,    setSelectedLang]    = useState(preferredLang);
  const [transData,       setTransData]       = useState(null);
  const [availableVerses, setAvailableVerses] = useState([]);
  const [loadingTrans,    setLoadingTrans]    = useState(false);
  const [playing,         setPlaying]         = useState(null);
  const [bookmarked,      setBookmarked]      = useState(false);
  const [bookmarkSaving,  setBookmarkSaving]  = useState(false);
  const audioRef = useRef(null);

  // Check bookmark status when verse changes
  useEffect(() => {
    if (!shloka || !user?.id) return;
    fetch(`${API}/bookmarks/${encodeURIComponent(user.id)}`)
      .then(r => r.json())
      .then(d => {
        setBookmarked((d.bookmarks || []).some(
          b => b.chapter === shloka.chapter && b.verse === shloka.verse
        ));
      })
      .catch(() => {});
  }, [shloka?.chapter, shloka?.verse, user?.id]);

  const toggleBookmark = async () => {
    if (!shloka || !user?.id || bookmarkSaving) return;
    setBookmarkSaving(true);
    try {
      if (bookmarked) {
        await fetch(`${API}/bookmark/${encodeURIComponent(user.id)}/${shloka.chapter}/${shloka.verse}`, { method: "DELETE" });
        setBookmarked(false);
      } else {
        await fetch(`${API}/bookmark`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ user_id: user.id, chapter: shloka.chapter, verse: shloka.verse }),
        });
        setBookmarked(true);
      }
    } catch {}
    setBookmarkSaving(false);
  };
 
  const loadShloka = async (chapter, verse, theme = "") => {
    setShloka(null);
    setCommentary(null);
    setCardUrl(null);
    setTransData(null);
    try {
      const url = chapter && verse
        ? `${API}/shloka/verse/${chapter}/${verse}`
        : `${API}/shloka/today`;
      const res  = await fetch(url);
      const data = await res.json();
      const s    = data.sanskrit ? data : MOCK_SHLOKA;
      setShloka(s);
      loadCommentary(s.chapter, s.verse, theme);
    } catch {
      setShloka(MOCK_SHLOKA);
      loadCommentary(MOCK_SHLOKA.chapter, MOCK_SHLOKA.verse, theme);
    }
  };

  const loadCommentary = async (chapter, verse, theme = "") => {
    setLoadingComm(true);
    try {
      const url  = theme
        ? `${API}/shloka/commentary/${chapter}/${verse}?theme=${encodeURIComponent(theme)}`
        : `${API}/shloka/commentary/${chapter}/${verse}`;
      const res  = await fetch(url);
      const data = await res.json();
      if (data.story) setCommentary(data);
    } catch {}
    finally { setLoadingComm(false); }
  };

  // Auto-translate whenever shloka + commentary are ready OR language changes
  useEffect(() => {
    if (!shloka) return;
    translateAll();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shloka, selectedLang, commentary]);

  const translateAll = async () => {
    if (!shloka) return;
    setLoadingTrans(true);
    try {
      const res = await fetch(`${API}/shloka/translate-all`, {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          verse_key:             `BG${shloka.chapter}_${shloka.verse}`,
          sanskrit:              shloka.sanskrit || "",
          verse_meaning:         shloka.meaning  || "",
          lang_code:             selectedLang,
          commentary_story:      commentary?.story      || "",
          commentary_meaning:    commentary?.meaning    || "",
          commentary_reflection: commentary?.reflection || "",
        }),
      });
      const data = await res.json();
      setTransData(data);
    } catch (e) {
      console.error("Translation error:", e);
    }
    setLoadingTrans(false);
  };

  const playAudio = (url, type) => {
    if (!url) return;
    if (audioRef.current) { audioRef.current.pause(); }
    if (playing === type) { setPlaying(null); return; }
    setPlaying(type);
    const a = new Audio(`${API}${url}`);
    audioRef.current = a;
    a.play();
    a.onended = () => setPlaying(null);
  };

  const playCommentarySequence = (data) => {
    if (playing === "comm") {
      if (audioRef.current) audioRef.current.pause();
      setPlaying(null);
      return;
    }
    const urls = [
      data?.commentary_story_audio,
      data?.commentary_meaning_audio,
      data?.commentary_reflection_audio,
    ].filter(Boolean).map(u => `${API}${u}`);
    if (!urls.length) return;
    setPlaying("comm");
    let idx = 0;
    const playNext = () => {
      if (idx >= urls.length) { setPlaying(null); return; }
      const a = new Audio(urls[idx++]);
      audioRef.current = a;
      a.play();
      a.onended = playNext;
    };
    playNext();
  };

  useEffect(() => {
    const theme = initTheme || initVerse?.theme || "";
    const verseUrl = theme
      ? `${API}/themes/${theme}`
      : `${API}/shloka/available-verses`;

    fetch(verseUrl)
      .then(r => r.json())
      .then(data => {
        // /themes/:id returns { verses: [...] }, available-verses returns [...] directly
        const raw = data.verses || data;
        // deduplicate by chapter+verse
        const seen = new Set();
        const verses = raw.filter(v => {
          const key = `${v.chapter}_${v.verse}`;
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        });
        setAvailableVerses(verses);
        if (initVerse) {
          const idx = verses.findIndex(v => v.chapter === initVerse.chapter && v.verse === initVerse.verse);
          if (idx !== -1) setVerseIdx(idx);
          loadShloka(initVerse.chapter, initVerse.verse, theme);
        } else if (verses.length > 0) {
          loadShloka(verses[0].chapter, verses[0].verse);
        }
      })
      .catch(() => {
        if (initVerse) loadShloka(initVerse.chapter, initVerse.verse, theme);
        else loadShloka();
      });
  }, []);

  useEffect(() => {
    if (shloka) generateCard(shloka);
  }, [shloka]);
 
  const generateCard = async (s) => {
    if (!s) return;
    setGenerating(true);
    try {
      const { url } = await generateShlokaCard(s, verseIdx % 4);
      setCardUrl(url);
    } catch (e) { console.error("Card failed:", e); }
    finally { setGenerating(false); }
  };
 
  const prevVerse = () => {
    if (!availableVerses.length) return;
    const i = (verseIdx - 1 + availableVerses.length) % availableVerses.length;
    setVerseIdx(i);
    const { chapter, verse } = availableVerses[i];
    loadShloka(chapter, verse);
  };

  const nextVerse = () => {
    if (!availableVerses.length) return;
    const i = (verseIdx + 1) % availableVerses.length;
    setVerseIdx(i);
    const { chapter, verse } = availableVerses[i];
    loadShloka(chapter, verse);
  };
 
  const handleDownload = () => {
    if (!cardUrl || !shloka) return;
    downloadCard(cardUrl, `vedsanga-BG${shloka.chapter}-${shloka.verse}.png`);
  };
 
  const handleWhatsApp = () => {
    if (!shloka) return;
    shareCardWhatsApp(cardUrl, shloka);
  };
 
  const handleCopy = () => {
    if (!shloka) return;
    navigator.clipboard.writeText(
      `🕉️ BG ${shloka.chapter}.${shloka.verse}\n\n${shloka.sanskrit}\n\n${shloka.meaning}\n\n#BhagavadGita #Vedsanga`
    );
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
 
  if (!shloka) return (
    <div className="page">
      <div style={{color:"var(--text-dim)",fontStyle:"italic",padding:"40px 0",textAlign:"center"}}>
        🕉️ Loading today's sacred verse...
      </div>
    </div>
  );
 
  const audioBtn = (label, type, url) => (
    <button onClick={() => playAudio(url, type)} disabled={!url} style={{
      display:"inline-flex", alignItems:"center", gap:"6px",
      background: playing === type ? "rgba(232,131,42,0.28)" : "rgba(232,131,42,0.10)",
      border:"1px solid rgba(232,131,42,0.4)", borderRadius:"8px",
      padding:"6px 16px", color: url ? "var(--saffron)" : "var(--text-dim)",
      cursor: url ? "pointer" : "default", fontSize:"0.95rem",
      fontFamily:"'Inter',sans-serif", transition:"all 0.2s",
    }}>
      {playing === type ? "🔊" : "▶"} {label}
    </button>
  );

  return (
    <div className="page">
      <div className="section-title">Daily Shloka</div>
      <div className="section-sub">नित्यदिव्य — Your daily Gita journey</div>

      {/* ── Language Preference Selector (TOP) ── */}
      <div style={{
        background:"var(--bg2)", border:"1px solid var(--border)",
        borderRadius:"var(--radius)", padding:"16px 20px", marginBottom:"20px",
      }}>
        <div style={{
          fontSize:"0.95rem", color:"var(--saffron)", letterSpacing:"normal",
          fontWeight:"700", marginBottom:"12px",
        }}>
          🌐 Language Preference {loadingTrans && <span style={{color:"var(--text-dim)",fontWeight:"normal",fontSize:"0.9rem"}}> — translating...</span>}
        </div>
        <div style={{display:"flex", flexWrap:"wrap", gap:"8px"}}>
          {LANG_OPTIONS.map(l => (
            <button key={l.code} onClick={() => setSelectedLang(l.code)} style={{
              padding:"5px 13px", borderRadius:"20px", cursor:"pointer",
              fontFamily:"'Inter',sans-serif", fontSize:"0.95rem",
              transition:"all 0.2s",
              background: selectedLang === l.code ? "var(--saffron)" : "transparent",
              color:      selectedLang === l.code ? "white" : "var(--text-dim)",
              border:     selectedLang === l.code ? "1px solid var(--saffron)" : "1px solid var(--border)",
            }}>
              {l.native}
            </button>
          ))}
        </div>
      </div>

      {/* ── Verse navigation ── */}
      <div style={{
        display:"flex", alignItems:"center", justifyContent:"space-between",
        marginBottom:"20px", background:"var(--bg2)",
        border:"1px solid var(--border)", borderRadius:"var(--radius)",
        padding:"12px 20px",
      }}>
        <button onClick={prevVerse} style={{
          background:"transparent", border:"1px solid var(--border)",
          borderRadius:"8px", padding:"8px 18px", color:"var(--text-dim)",
          cursor:"pointer", fontSize:"1rem", transition:"all 0.2s",
        }}>← Prev</button>
        <div style={{textAlign:"center"}}>
          <div style={{fontFamily:"'Inter',sans-serif",fontWeight:700,fontSize:"0.95rem",color:"var(--saffron)"}}>
            Chapter {shloka.chapter} · Verse {shloka.verse}
          </div>
          <div style={{fontSize:"0.9rem",color:"var(--text-dim)",marginTop:"4px"}}>
            Day {verseIdx+1} of your Gita journey
          </div>
        </div>
        <button onClick={nextVerse} style={{
          background:"transparent", border:"1px solid var(--border)",
          borderRadius:"8px", padding:"8px 18px", color:"var(--text-dim)",
          cursor:"pointer", fontSize:"1rem", transition:"all 0.2s",
        }}>Next →</button>
      </div>

      {/* ── Shloka text card ── */}
      <div className="shloka-card">
        <div className="shloka-badge">🕉 Today's Verse</div>
        <div className="shloka-ref">
          Bhagavad Gita — Chapter {shloka.chapter}, Verse {shloka.verse}
        </div>

        {/* Sanskrit + its own audio */}
        <div className="shloka-sanskrit">{shloka.sanskrit}</div>
        <div className="shloka-translit">{shloka.transliteration}</div>
        <div style={{marginBottom:"14px"}}>
          {audioBtn("Sanskrit Audio", "sanskrit", transData?.sanskrit_audio_url)}
        </div>

        <div className="divider-line"><div className="divider-diamond"/></div>

        {/* Translated meaning + audio */}
        <div className="shloka-meaning">
          {transData?.verse_meaning || shloka.meaning}
          {transData && selectedLang !== "en" && (
            <span style={{
              display:"inline-block", marginLeft:"10px",
              fontSize:"0.9rem", color:"var(--text-dim)", fontStyle:"italic"
            }}>
              ({LANG_OPTIONS.find(l => l.code === selectedLang)?.name})
            </span>
          )}
        </div>
        <div style={{marginBottom:"18px"}}>
          {audioBtn(`${LANG_OPTIONS.find(l=>l.code===selectedLang)?.name || "English"} Audio`, "verse", transData?.verse_audio_url)}
        </div>

        <div className="share-row">
          <button className="share-btn whatsapp" onClick={handleWhatsApp}>💬 WhatsApp</button>
          <button className="share-btn instagram" onClick={() => window.open("https://www.instagram.com/","_blank")}>📸 Instagram</button>
          <button className="share-btn" onClick={handleCopy}>{copied ? "✅ Copied!" : "📋 Copy"}</button>
          <button className="share-btn"
            style={{background:"rgba(232,131,42,0.15)",borderColor:"var(--saffron)",color:"var(--saffron)"}}
            onClick={handleDownload}>⬇️ Download</button>
          {user && (
            <button className="share-btn" onClick={toggleBookmark} disabled={bookmarkSaving}
              style={{
                background: bookmarked ? "rgba(232,131,42,0.18)" : "transparent",
                borderColor: bookmarked ? "var(--saffron)" : undefined,
                color: bookmarked ? "var(--saffron)" : undefined,
              }}>
              {bookmarked ? "🔖 Saved" : "🔖 Save"}
            </button>
          )}
        </div>
      </div>

      {/* ── Commentary section ── */}
      <div style={{marginBottom:"28px"}}>
        <div style={{
          fontFamily:"'Inter',sans-serif", fontWeight:700,
          fontSize:"1.1rem", color:"var(--saffron)",
          marginBottom:"16px", display:"flex", alignItems:"center", justifyContent:"space-between",
        }}>
          <span>
            📖 Commentary
            <span style={{fontSize:"0.9rem",color:"var(--text-dim)",fontFamily:"'Inter',sans-serif",fontStyle:"italic",marginLeft:"8px",fontWeight:400}}>
              — a deeper reading
            </span>
          </span>
          {(transData?.commentary_story_audio || transData?.commentary_audio_url) && (
            <button onClick={() => playCommentarySequence(transData)} style={{
              display:"inline-flex", alignItems:"center", gap:"6px",
              background: playing === "comm" ? "rgba(232,131,42,0.28)" : "rgba(232,131,42,0.10)",
              border:"1px solid rgba(232,131,42,0.4)", borderRadius:"8px",
              padding:"6px 16px", color:"var(--saffron)",
              fontFamily:"'Inter',sans-serif", fontSize:"0.95rem", cursor:"pointer",
            }}>
              {playing === "comm" ? "⏸ Pause" : "🔊 Listen to Commentary"}
            </button>
          )}
        </div>

        {loadingComm ? (
          <div style={{
            background:"var(--bg2)", border:"1px solid var(--border)",
            borderRadius:"var(--radius)", padding:"28px",
            textAlign:"center", color:"var(--text-dim)", fontStyle:"italic"
          }}>
            ✨ Loading commentary...
          </div>
        ) : (commentary || transData) ? (
          <div style={{display:"flex", flexDirection:"column", gap:"16px"}}>

            {/* Story */}
            <div style={{
              background:"var(--bg2)", border:"1px solid var(--border)",
              borderRadius:"var(--radius)", padding:"22px 26px",
              borderLeft:"3px solid var(--saffron)",
            }}>
              <div style={{
                fontSize:"0.98rem", color:"var(--saffron)",
                letterSpacing:"normal",
                marginBottom:"12px", fontWeight:"700",
                fontFamily:"'Inter',sans-serif",
              }}>
                Prasanga · Context
              </div>
              <div style={{fontSize:"1.2rem", lineHeight:"1.9", color:"var(--text)", fontWeight:"400"}}>
                {transData?.commentary_story || commentary?.story}
              </div>
            </div>

            {/* Modern meaning */}
            <div style={{
              background:"var(--bg2)", border:"1px solid var(--border)",
              borderRadius:"var(--radius)", padding:"22px 26px",
              borderLeft:"3px solid #C9953A",
            }}>
              <div style={{
                fontSize:"0.98rem", color:"#a16207",
                letterSpacing:"normal",
                marginBottom:"12px", fontWeight:"700",
                fontFamily:"'Inter',sans-serif",
              }}>
                Artha · Meaning For You
              </div>
              <div style={{fontSize:"1.2rem", lineHeight:"1.9", color:"var(--text)", fontWeight:"400"}}>
                {transData?.commentary_meaning || commentary?.meaning}
              </div>
            </div>

            {/* Reflection */}
            <div style={{
              background:"linear-gradient(135deg, rgba(232,131,42,0.08), rgba(201,149,58,0.05))",
              border:"1px solid rgba(232,131,42,0.3)",
              borderRadius:"var(--radius)", padding:"22px 26px",
            }}>
              <div style={{
                fontSize:"0.98rem", color:"var(--saffron)",
                letterSpacing:"normal",
                marginBottom:"12px", fontWeight:"700",
                fontFamily:"'Inter',sans-serif",
              }}>
                Chintan · Reflection
              </div>
              <div style={{
                fontSize:"1.2rem", lineHeight:"1.9",
                color:"var(--text)", fontStyle:"italic", fontWeight:"500",
              }}>
                "{transData?.commentary_reflection || commentary?.reflection}"
              </div>
            </div>

          </div>
        ) : (
          <div style={{
            background:"var(--bg2)", border:"1px solid var(--border)",
            borderRadius:"var(--radius)", padding:"28px",
            textAlign:"center", color:"var(--text-dim)"
          }}>
            Commentary not available for this verse yet.
          </div>
        )}
      </div>

      {/* ── Image card ── */}
      <div style={{marginBottom:"28px"}}>
        <div style={{
          fontFamily:"'Inter',sans-serif", fontWeight:700,
          fontSize:"1rem", color:"var(--gold)", marginBottom:"14px"
        }}>
          📱 Shareable Image Card
        </div>

        {generating ? (
          <div style={{
            background:"var(--bg2)", border:"1px solid var(--border)",
            borderRadius:"var(--radius)", padding:"40px",
            textAlign:"center", color:"var(--text-dim)", fontStyle:"italic"
          }}>
            ✨ Generating card...
          </div>
        ) : cardUrl ? (
          <div>
            <img src={cardUrl} alt="Shloka card" style={{
              width:"100%", maxWidth:"480px", borderRadius:"12px",
              border:"1px solid var(--border)", display:"block",
              marginBottom:"14px", boxShadow:"0 8px 32px rgba(0,0,0,0.5)",
            }}/>
            <div style={{display:"flex", gap:"10px", flexWrap:"wrap"}}>
              <button className="btn" onClick={handleDownload}>⬇️ Download PNG</button>
              <button className="btn"
                style={{background:"linear-gradient(135deg,#25D366,#1da851)"}}
                onClick={handleWhatsApp}>💬 Save + WhatsApp</button>
              <button className="btn btn-outline" onClick={() => generateCard(shloka)}>🔄 Regenerate</button>
            </div>
            <div style={{marginTop:"10px",fontSize:"0.9rem",color:"var(--text-dim)",fontStyle:"italic"}}>
              💡 Download image → open WhatsApp → attach from gallery
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}

        

// ══════════════════════════════════════════════════════════════════════════════
// CHAT PAGE
// ══════════════════════════════════════════════════════════════════════════════
// ── Replace your ChatPage function in App.jsx with this ──────────────────────
//
// ADD THIS CSS inside your existing css = `...` string in App.jsx:
//
//   /* ── Chat with History Sidebar ── */
//   .chat-layout {
//     display: flex;
//     height: calc(100vh - 64px);
//     overflow: hidden;
//   }
//   .chat-sidebar {
//     width: 260px;
//     min-width: 260px;
//     background: linear-gradient(180deg, #080613, #0D0818);
//     border-right: 1px solid rgba(201,149,58,0.2);
//     display: flex;
//     flex-direction: column;
//     overflow: hidden;
//   }
//   .chat-sidebar-header {
//     padding: 16px;
//     border-bottom: 1px solid rgba(201,149,58,0.15);
//   }
//   .new-chat-btn {
//     width: 100%;
//     background: linear-gradient(135deg, rgba(232,131,42,0.15), rgba(201,149,58,0.1));
//     border: 1px solid rgba(232,131,42,0.35);
//     border-radius: 10px;
//     padding: 11px 16px;
//     color: var(--saffron);
//     font-family: 'Crimson Pro', serif;
//     font-size: 0.95rem;
//     cursor: pointer;
//     display: flex;
//     align-items: center;
//     gap: 8px;
//     transition: all 0.2s;
//   }
//   .new-chat-btn:hover {
//     background: rgba(232,131,42,0.22);
//     border-color: var(--saffron);
//   }
//   .sessions-list {
//     flex: 1;
//     overflow-y: auto;
//     padding: 8px;
//     scrollbar-width: thin;
//     scrollbar-color: var(--border) transparent;
//   }
//   .session-group-label {
//     font-size: 0.7rem;
//     color: var(--text-dim);
//     letter-spacing: 0.1em;
//     text-transform: uppercase;
//     padding: 10px 8px 4px;
//   }
//   .session-item {
//     display: flex;
//     align-items: center;
//     gap: 8px;
//     padding: 10px 12px;
//     border-radius: 8px;
//     cursor: pointer;
//     transition: all 0.15s;
//     margin-bottom: 2px;
//     group: true;
//   }
//   .session-item:hover { background: rgba(232,131,42,0.08); }
//   .session-item.active {
//     background: rgba(232,131,42,0.14);
//     border: 1px solid rgba(232,131,42,0.25);
//   }
//   .session-title {
//     flex: 1;
//     font-size: 0.88rem;
//     color: var(--text-dim);
//     white-space: nowrap;
//     overflow: hidden;
//     text-overflow: ellipsis;
//     font-family: 'Crimson Pro', serif;
//   }
//   .session-item.active .session-title { color: var(--cream); }
//   .session-item:hover .session-title { color: var(--text); }
//   .session-delete {
//     opacity: 0;
//     background: none;
//     border: none;
//     color: var(--text-dim);
//     cursor: pointer;
//     font-size: 0.8rem;
//     padding: 2px 4px;
//     border-radius: 4px;
//     transition: all 0.15s;
//   }
//   .session-item:hover .session-delete { opacity: 1; }
//   .session-delete:hover { color: #ff6b6b; background: rgba(255,107,107,0.1); }
//   .chat-main {
//     flex: 1;
//     display: flex;
//     flex-direction: column;
//     overflow: hidden;
//     min-width: 0;
//   }
//   .chat-main-header {
//     padding: 18px 32px 14px;
//     border-bottom: 1px solid var(--border);
//     background: linear-gradient(135deg, var(--bg2), var(--bg3));
//   }
//   .chat-messages {
//     flex: 1;
//     overflow-y: auto;
//     padding: 32px 40px;
//     display: flex;
//     flex-direction: column;
//     gap: 32px;
//     scrollbar-width: thin;
//     scrollbar-color: var(--border) transparent;
//   }
//   .msg { display: flex; gap: 14px; animation: fadein 0.3s ease; }
//   .msg-user { flex-direction: row-reverse; }
//   .msg-avatar {
//     width: 40px; height: 40px; border-radius: 50%; flex-shrink: 0;
//     display: flex; align-items: center; justify-content: center;
//     font-weight: 600;
//   }
//   .msg-avatar.user {
//     background: linear-gradient(135deg, var(--saffron), var(--gold));
//     color: white; font-size: 1rem;
//   }
//   .msg-avatar.ai {
//     background: var(--bg3);
//     border: 1px solid var(--border);
//     font-family: 'Noto Sans Devanagari', serif;
//     color: var(--saffron); font-size: 1.3rem;
//   }
//   .msg-content { display: flex; flex-direction: column; gap: 6px; max-width: 82%; }
//   .msg-user .msg-content { align-items: flex-end; }
//   .msg-emotion {
//     font-size: 0.8rem; color: var(--text-dim);
//     letter-spacing: 0.06em; padding: 0 4px;
//   }
//   .msg-bubble {
//     padding: 18px 24px;
//     border-radius: 16px;
//     font-size: 1.12rem;
//     line-height: 1.9;
//   }
//   .msg-user .msg-bubble {
//     background: linear-gradient(135deg, rgba(232,131,42,0.28), rgba(180,110,30,0.22));
//     border: 1px solid rgba(232,131,42,0.5);
//     color: #FFF8F0;
//     border-radius: 16px 4px 16px 16px;
//     font-weight: 500;
//   }
//   .msg-ai .msg-bubble {
//     background: linear-gradient(135deg, #0F0B1E, #130D22);
//     border: 1px solid rgba(201,149,58,0.3);
//     color: #EDE0C8;
//     border-radius: 4px 16px 16px 16px;
//   }
//   .msg-time { font-size: 0.75rem; color: var(--text-dim); padding: 0 4px; }
//   .typing-indicator {
//     display: flex; gap: 5px; align-items: center;
//     padding: 18px 24px;
//     background: linear-gradient(135deg, #0F0B1E, #130D22);
//     border: 1px solid rgba(201,149,58,0.3);
//     border-radius: 4px 16px 16px 16px;
//     width: fit-content;
//   }
//   .typing-dot {
//     width: 7px; height: 7px; border-radius: 50%;
//     background: var(--saffron); opacity: 0.5;
//     animation: typing-bounce 1.2s ease-in-out infinite;
//   }
//   .typing-dot:nth-child(2) { animation-delay: 0.2s; }
//   .typing-dot:nth-child(3) { animation-delay: 0.4s; }
//   @keyframes typing-bounce {
//     0%,60%,100% { transform: translateY(0); opacity: 0.5; }
//     30% { transform: translateY(-8px); opacity: 1; }
//   }
//   .chat-input-area {
//     padding: 14px 32px 18px;
//     border-top: 1px solid var(--border);
//     background: rgba(6,3,10,0.9);
//     backdrop-filter: blur(12px);
//   }
//   .chat-input-row {
//     display: flex; gap: 12px; align-items: flex-end;
//     background: linear-gradient(135deg, #0D0818, #130D22);
//     border: 1.5px solid rgba(201,149,58,0.35);
//     border-radius: 18px;
//     padding: 10px 10px 10px 22px;
//     transition: all 0.25s;
//     box-shadow: 0 2px 12px rgba(0,0,0,0.3);
//   }
//   .chat-input-row:focus-within {
//     border-color: var(--saffron);
//     box-shadow: 0 0 0 3px rgba(232,131,42,0.12), 0 0 20px rgba(232,131,42,0.08);
//   }
//   .chat-input {
//     flex: 1; background: transparent; border: none;
//     color: var(--text); font-family: 'Crimson Pro', serif;
//     font-size: 1.08rem; outline: none; resize: none;
//     max-height: 120px; min-height: 28px; line-height: 1.6;
//     padding: 6px 0;
//   }
//   .chat-input::placeholder { color: var(--text-dim); }
//   .send-btn {
//     background: linear-gradient(135deg, var(--saffron), var(--gold));
//     border: none; border-radius: 14px;
//     width: 48px; height: 48px; flex-shrink: 0;
//     display: flex; align-items: center; justify-content: center;
//     cursor: pointer; transition: all 0.2s; font-size: 1.2rem;
//     box-shadow: 0 2px 12px rgba(232,131,42,0.35);
//   }
//   .send-btn:hover { opacity: 0.9; transform: scale(1.05); }
//   .send-btn:disabled { opacity: 0.3; cursor: not-allowed; transform: none; }
//   .quick-prompts {
//     display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 12px;
//   }
//   .quick-prompt {
//     background: var(--bg3); border: 1px solid var(--border);
//     border-radius: 20px; padding: 7px 16px;
//     font-size: 0.88rem; color: var(--text-dim);
//     cursor: pointer; transition: all 0.2s;
//     font-family: 'Crimson Pro', serif;
//   }
//   .quick-prompt:hover { border-color: var(--saffron); color: var(--saffron); }
//   .empty-chat {
//     flex: 1; display: flex; flex-direction: column;
//     align-items: center; justify-content: center;
//     color: var(--text-dim); text-align: center; padding: 40px;
//   }
//   .empty-om {
//     font-family: 'Noto Sans Devanagari', serif;
//     font-size: 4rem; color: var(--saffron); opacity: 0.4;
//     margin-bottom: 16px;
//     filter: drop-shadow(0 0 20px rgba(232,131,42,0.3));
//   }
//   .empty-title {
//     font-family: 'Cinzel Decorative', serif;
//     font-size: 1.3rem; color: var(--text-dim);
//     margin-bottom: 8px;
//   }
//   .empty-sub { font-size: 1rem; color: var(--text-dim); font-style: italic; }

// ── Helper: group sessions by date ───────────────────────────────────────────
function groupByDate(sessions) {
  const today     = new Date().toDateString();
  const yesterday = new Date(Date.now() - 86400000).toDateString();
  const groups    = { Today: [], Yesterday: [], "Previous 7 days": [], Older: [] };

  sessions.forEach(s => {
    const d = new Date(s.updated_at).toDateString();
    if (d === today)           groups["Today"].push(s);
    else if (d === yesterday)  groups["Yesterday"].push(s);
    else if (Date.now() - new Date(s.updated_at) < 7*86400000) groups["Previous 7 days"].push(s);
    else                       groups["Older"].push(s);
  });
  return groups;
}

// ── EMOTION ICONS ─────────────────────────────────────────────────────────────
const EMOTION_ICONS = {
  joy:"🌸", sadness:"🌧", anger:"🔥", fear:"🌊",
  neutral:"🕉️", love:"💛", anxiety:"🌿", surprise:"✨",
};

// ── QUICK PROMPTS ─────────────────────────────────────────────────────────────
const QUICK = [
  "I feel lost in life 🌧",
  "What does Gita say about karma?",
  "I'm going through a hard time",
  "How to find inner peace?",
];

// ══════════════════════════════════════════════════════════════════════════════
// CHAT PAGE
// ══════════════════════════════════════════════════════════════════════════════

function ChatPage({ user, companionCtx, onCompanionCtxUsed, initText, onInitTextUsed, onNavigate }) {
  const [sessions,    setSessions]    = useState([]);
  const [activeId,    setActiveId]    = useState(null);
  const [messages,    setMessages]    = useState([]);
  const [input,       setInput]       = useState("");
  const [loading,     setLoading]     = useState(false);
  const [loadingHist, setLoadingHist] = useState(false);
  const [showDrawer,  setShowDrawer]  = useState(false);
  const bottomRef           = useRef(null);
  const inputRef            = useRef(null);
  const companionFired      = useRef(false);
  const initFired           = useRef(false);
  const journeySuggested    = useRef(false);
  const sessionNamed        = useRef(false);

  // Load sessions on mount
  useEffect(() => { fetchSessions(); }, []);

  // Auto-send from Home quick-ask
  useEffect(() => {
    if (!initText || initFired.current) return;
    initFired.current = true;
    setTimeout(() => {
      sendMessage(initText);
      onInitTextUsed?.();
    }, 500);
  }, [initText]); // eslint-disable-line react-hooks/exhaustive-deps

  // Auto-send journey context when companion opens
  useEffect(() => {
    if (!companionCtx || companionFired.current) return;
    companionFired.current = true;
    const { day, title, verseRef, emotion, score, scoreLabel } = companionCtx;
    const shiftNote = score >= 4
      ? `Something in this verse moved me — I came in feeling ${emotion} and left at ${score}/5.`
      : score <= 2
      ? `The verse barely moved me — I still feel the weight of ${emotion}, only at ${score}/5 after reading.`
      : `Something shifted a little — from ${emotion} to ${score}/5, but I'm not sure what changed.`;
    const msg = `I just completed Day ${day} of my ${title} journey. Today's verse was ${verseRef}. ${shiftNote} Help me understand what happened there.`;
    // Small delay so session is ready
    setTimeout(() => {
      sendMessage(msg);
      onCompanionCtxUsed?.();
    }, 400);
  }, [companionCtx]);

  // Auto scroll
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const fetchSessions = async () => {
    try {
      const res  = await fetch(`${API}/chat/sessions/${user.email}`);
      const data = await res.json();
      setSessions(data.sessions || []);
    } catch {}
  };

  const startNewChat = async () => {
    sessionNamed.current = false;
    try {
      const res  = await fetch(`${API}/chat/sessions/new?user_id=${encodeURIComponent(user.email)}`, {method:"POST"});
      const data = await res.json();
      setSessions(prev => [data, ...prev]);
      setActiveId(data.session_id);

      // Fetch user patterns for smart greeting
      let greeting = `Namaste ${user.name} 🙏\n\nI am here with wisdom from the Bhagavad Gita.\n\nWhat is on your heart today?`;
      try {
        const pRes = await fetch(`${API}/user/patterns/${encodeURIComponent(user.email)}`);
        const p    = await pRes.json();
        if (p.has_history && p.session_count >= 2) {
          const themeVariants = {
            relationship: [
              "I know you have been carrying something around matters of the heart",
              "Last time you were holding something that had to do with someone close to you",
              "Something around love and connection has been on your mind",
            ],
            career: [
              "I remember you've been navigating something with your work and path",
              "Something around purpose and work has been sitting with you",
              "You have been wrestling with questions about what you are building and why",
            ],
            health: [
              "I know your body has been through difficulty lately",
              "You have been carrying something physical alongside everything else",
              "Last time there was something about your body and your energy",
            ],
            purpose: [
              "I know you've been searching for meaning and direction",
              "The question of what this is all for has been sitting with you",
              "You have been in that place where purpose feels just out of reach",
            ],
            spirituality: [
              "I've seen you going deeper into your spiritual practice",
              "Something in you has been reaching toward a deeper understanding",
              "You have been asking the kinds of questions most people avoid",
            ],
            anxiety: [
              "I know there has been some heaviness weighing on you",
              "There has been a weight in the background of our conversations",
              "Something has been unsettled beneath the surface lately",
            ],
            family: [
              "I know there have been matters close to home on your mind",
              "Something around the people nearest to you has been present",
              "Last time there was something with family that was still unresolved",
            ],
          };
          const closings = [
            "Is that still with you today, or is something new on your heart?",
            "What is present for you today?",
            "Where are you right now?",
          ];
          const moodNotes = {
            improving:  "Something in me senses you are finding your footing.",
            struggling: "I am here — no rush, no judgment.",
            stable:     "I am here with you.",
          };
          // Milestone
          if (p.session_count === 7) {
            greeting = `Namaste ${user.name} 🙏\n\nOne week of walking this path together — that itself is tapasya.\n\nWhat brings you here today?`;
          } else if (p.session_count === 21) {
            greeting = `Namaste ${user.name} 🙏\n\n21 conversations — the Gita was spoken in 18 chapters, and you have gone deeper than most ever do.\n\nWhat is on your heart?`;
          } else {
            const topic    = p.last_topic || (p.themes && p.themes[0]) || "";
            const variants = themeVariants[topic] || [
              "I have been holding our past conversations with care",
              "Something from our last conversation has stayed with me",
              "You have been sitting with something real",
            ];
            const v       = p.session_count % 3;
            const phrase  = variants[v];
            const closing = closings[v];
            const moodNote = moodNotes[p.mood_trend] || "I am here with you.";
            greeting = `Namaste ${user.name} 🙏\n\n${phrase}. ${moodNote}\n\n${closing}`;
          }
        }
      } catch {}

      setMessages([{
        role:    "ai",
        text:    greeting,
        emotion: "neutral",
        time:    new Date().toLocaleTimeString([], {hour:"2-digit",minute:"2-digit"}),
      }]);
    } catch {}
  };

  const openSession = async (sessionId) => {
    setActiveId(sessionId);
    sessionNamed.current = false;
    setLoadingHist(true);
    try {
      const res  = await fetch(`${API}/chat/sessions/${user.email}/${sessionId}/messages`);
      const data = await res.json();
      if (data.messages?.length > 0) {
        setMessages(data.messages);
      } else {
        setMessages([{
          role:    "ai",
          text:    `Namaste ${user.name} 🙏\n\nI am here with wisdom from the Bhagavad Gita.\n\nWhat is on your heart today?`,
          emotion: "neutral",
          time:    "",
        }]);
      }
    } catch {}
    finally { setLoadingHist(false); }
  };

  const deleteSession = async (e, sessionId) => {
    e.stopPropagation();
    try {
      await fetch(`${API}/chat/sessions/${user.email}/${sessionId}`, {method:"DELETE"});
      setSessions(prev => prev.filter(s => s.session_id !== sessionId));
      if (activeId === sessionId) {
        setActiveId(null);
        setMessages([]);
      }
    } catch {}
  };

  const sendMessage = async (text) => {
    const query = (text || input).trim();
    if (!query || loading) return;

    // Create session if none active
    let sid = activeId;
    if (!sid) {
      try {
        const res  = await fetch(`${API}/chat/sessions/new?user_id=${encodeURIComponent(user.email)}`, {method:"POST"});
        const data = await res.json();
        sid = data.session_id;
        setSessions(prev => [data, ...prev]);
        setActiveId(sid);
      } catch { return; }
    }

    setInput("");
    const time = new Date().toLocaleTimeString([], {hour:"2-digit",minute:"2-digit"});
    const userMsg = {role:"user", text:query, time};
    setMessages(prev => [...prev, userMsg]);
    setLoading(true);

    // Save user message
    try {
      await fetch(`${API}/chat/sessions/${sid}/message?role=user&text=${encodeURIComponent(query)}&user_id=${encodeURIComponent(user.email)}`, {method:"POST"});
    } catch {}

    try {
      const res  = await fetch(`${API}/chat`, {
        method:  "POST",
        headers: {"Content-Type":"application/json"},
        body:    JSON.stringify({query, user_id: user.email, session_id: sid, user_uid: user.id, user_name: user.name}),
      });
      const data = await res.json();
      const suggestion = (!journeySuggested.current && data.journey_suggestion)
        ? data.journey_suggestion : null;
      if (suggestion) journeySuggested.current = true;

      const aiMsg = {
        role:              "ai",
        text:              data.answer || "Let me reflect on this...",
        emotion:           data.emotion || "neutral",
        time:              new Date().toLocaleTimeString([], {hour:"2-digit",minute:"2-digit"}),
        journey_suggestion: suggestion,
      };
      setMessages(prev => [...prev, aiMsg]);

      // Save AI message
      await fetch(`${API}/chat/sessions/${sid}/message?role=ai&text=${encodeURIComponent(aiMsg.text)}&user_id=${encodeURIComponent(user.email)}&emotion=${aiMsg.emotion}`, {method:"POST"});

      // Generate AI session name after 3rd exchange (6 messages: 3 user + 3 AI)
      setMessages(prev => {
        const total = prev.length; // includes the aiMsg we just added
        if (!sessionNamed.current && total >= 6) {
          sessionNamed.current = true;
          fetch(`${API}/chat/sessions/${sid}/generate-name`, { method: "POST" })
            .then(() => fetchSessions())
            .catch(() => {});
        }
        return prev;
      });

      // Refresh sessions to update titles
      fetchSessions();
    } catch {
      setMessages(prev => [...prev, {
        role:"ai", text:"Unable to connect. Please ensure backend is running.", emotion:"neutral", time,
      }]);
    } finally {
      setLoading(false);
      inputRef.current?.focus();
    }
  };

  const handleKey = (e) => {
    if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); sendMessage(); }
  };

  const groups = groupByDate(sessions);
  const isMobile = window.innerWidth <= 767;

  return (
    <>
    <style>{`
      .chat-sidebar { background: #FFFFFF !important; border-right: 1px solid var(--border) !important; }
      .chat-sidebar-header { padding:16px !important; border-bottom: 1px solid var(--border) !important; background: #FFFFFF !important; }
      .new-chat-btn { background: var(--saffron) !important; color:#fff !important; border:none !important; border-radius:10px !important; padding:12px 16px !important; width:100% !important; font-family:'Inter',sans-serif !important; font-weight:600 !important; font-size:1rem !important; cursor:pointer !important; display:flex !important; align-items:center !important; gap:8px !important; box-shadow:var(--card-shadow) !important; }
      .sessions-list { flex:1 !important; overflow-y:auto !important; padding:10px 8px !important; }
      .session-group-label { font-size:0.95rem !important; color:var(--text-dim) !important; letter-spacing:normal !important; text-transform:none !important; padding:12px 10px 5px !important; font-family:'Inter',sans-serif !important; font-weight:600 !important; display:block !important; }
      .session-item { display:flex !important; align-items:center !important; gap:8px !important; padding:10px 12px !important; border-radius:10px !important; cursor:pointer !important; margin-bottom:3px !important; border:1px solid transparent !important; }
      .session-item:hover { background:rgba(232,131,42,0.08) !important; border-color:rgba(232,131,42,0.2) !important; }
      .session-item.active { background:rgba(232,131,42,0.12) !important; border:1px solid var(--saffron) !important; }
      .session-title { font-size:1rem !important; color:var(--text) !important; white-space:nowrap !important; overflow:hidden !important; text-overflow:ellipsis !important; flex:1 !important; font-family:'Inter',sans-serif !important; }
      .session-item.active .session-title { color:var(--saffron) !important; font-weight:600 !important; }
      .session-delete { opacity:0 !important; background:none !important; border:none !important; cursor:pointer !important; font-size:0.95rem !important; color:var(--text-dim) !important; padding:2px 6px !important; border-radius:4px !important; }
      .session-item:hover .session-delete { opacity:1 !important; }
      .chat-main-header { padding:18px 32px 14px !important; border-bottom:1px solid var(--border) !important; background:#FFFFFF !important; }
      .msg-user .msg-bubble { background:linear-gradient(135deg,#E8832A,#C9953A) !important; color:#ffffff !important; border:none !important; }
      .msg-ai .msg-bubble { background:#FFFFFF !important; border:1px solid rgba(201,149,58,0.25) !important; border-left:3px solid #C9953A !important; color:#2E0E00 !important; }
      .chat-input-area { background:#FFFFFF !important; border:1px solid var(--border) !important; border-radius:22px !important; box-shadow:var(--card-shadow) !important; margin:0 12px 12px !important; padding:12px 14px 12px 20px !important; display:flex !important; align-items:flex-end !important; gap:10px !important; }
      .chat-input-area:focus-within { border-color:var(--saffron) !important; box-shadow:var(--card-shadow-hover) !important; }
      .chat-input-row { background:transparent !important; border:none !important; padding:0 !important; box-shadow:none !important; flex:1 !important; }
      .chat-input { color:var(--text) !important; font-size:1.1rem !important; font-family:'Inter',sans-serif !important; }
      .chat-input::placeholder { color:var(--text-dim) !important; opacity:1 !important; font-style:normal !important; text-shadow:none !important; }
      .send-btn { background:var(--saffron) !important; border-radius:16px !important; width:46px !important; height:46px !important; box-shadow:var(--card-shadow) !important; flex-shrink:0 !important; display:flex !important; align-items:center !important; justify-content:center !important; }
      .msg-bubble { min-width:80px !important; word-break:break-word !important; font-size:1.22rem !important; line-height:1.8 !important; }
      .empty-chat { flex:1 !important; display:flex !important; flex-direction:column !important; align-items:center !important; justify-content:center !important; text-align:center !important; padding:48px 40px !important; background:#FFFFFF !important; }
      .empty-om { font-family:'Noto Sans Devanagari',serif !important; font-size:5.5rem !important; color:var(--saffron) !important; opacity:0.35 !important; margin-bottom:24px !important; filter:drop-shadow(0 0 24px var(--glow)) !important; line-height:1 !important; }
      .empty-title { font-family:'Inter',sans-serif !important; font-weight:700 !important; font-size:1.7rem !important; color:var(--text) !important; margin-bottom:12px !important; letter-spacing:normal !important; }
      .empty-sub { font-size:1.1rem !important; color:var(--text-dim) !important; font-style:normal !important; margin-bottom:10px !important; font-family:'Inter',sans-serif !important; max-width:480px !important; line-height:1.6 !important; }
      .quick-prompts { display:flex !important; gap:14px !important; flex-wrap:wrap !important; justify-content:center !important; max-width:660px !important; margin-top:8px !important; }
      .quick-prompt { background:#FFFFFF !important; border:1px solid var(--border) !important; border-left:3px solid var(--saffron) !important; border-radius:12px !important; padding:14px 22px !important; font-size:1rem !important; color:var(--text) !important; cursor:pointer !important; font-family:'Inter',sans-serif !important; text-align:left !important; display:flex !important; align-items:center !important; gap:10px !important; box-shadow:var(--card-shadow) !important; min-width:240px !important; flex:1 !important; max-width:300px !important; transition:all 0.2s !important; }
      .quick-prompt:hover { background:rgba(232,131,42,0.06) !important; border-color:var(--saffron) !important; border-left-color:var(--saffron) !important; box-shadow:var(--card-shadow-hover) !important; transform:translateY(-2px) !important; color:var(--saffron) !important; }
      .qp-icon { font-size:1.15rem !important; flex-shrink:0 !important; }
      .qp-text { font-size:1rem !important; line-height:1.4 !important; }

      /* ── Mobile chat top bar ── */
      .chat-mobile-bar { display:none; }
      @media (max-width:767px) {
        .chat-mobile-bar {
          display:flex !important; align-items:center; justify-content:space-between;
          padding:10px 14px; background:#FFFFFF;
          border-bottom:1px solid var(--border);
          flex-shrink:0;
        }
        .chat-mob-btn {
          background:none; border:none; cursor:pointer; padding:6px 10px;
          border-radius:8px; font-size:1.2rem; color:var(--text);
          display:flex; align-items:center; gap:6px;
          -webkit-tap-highlight-color:transparent;
        }
        .chat-mob-btn:active { background:rgba(232,131,42,0.1); }
        .chat-mob-title {
          font-family:'Inter',sans-serif; font-weight:600; font-size:1rem;
          color:var(--text); letter-spacing:normal;
        }
        .chat-main-header { display:none !important; }
        .chat-messages { padding:12px 12px 8px !important; gap:16px !important; }
        .msg-bubble { font-size:1.08rem !important; line-height:1.7 !important; padding:12px 16px !important; min-width:80px !important; }
        .msg-content { max-width:88% !important; }
        .msg-avatar { width:34px !important; height:34px !important; font-size:0.85rem !important; }

        /* ── History drawer ── */
        .chat-history-overlay {
          position:fixed; inset:0; z-index:490;
          background:rgba(0,0,0,0.45); backdrop-filter:blur(2px);
        }
        .chat-history-drawer {
          position:fixed; top:0; left:0; bottom:0; z-index:491;
          width:min(80vw, 300px);
          background:#FFFFFF;
          border-right:1px solid var(--border);
          display:flex; flex-direction:column;
          transform:translateX(0); animation:drawerIn 0.22s ease;
          overflow:hidden;
        }
        @keyframes drawerIn { from { transform:translateX(-100%); } to { transform:translateX(0); } }
        .chat-history-drawer-header {
          padding:14px 16px; display:flex; align-items:center; justify-content:space-between;
          border-bottom:1px solid var(--border);
          background:#FFFFFF;
        }
        .chat-history-drawer-title {
          font-family:'Inter',sans-serif; font-weight:600; font-size:1rem; color:var(--text);
          letter-spacing:normal;
        }
        .drawer-close-btn {
          background:none; border:none; cursor:pointer; font-size:1.1rem;
          color:var(--text-dim); padding:4px 8px; border-radius:6px;
          -webkit-tap-highlight-color:transparent;
        }
        .drawer-new-chat-btn {
          margin:12px 12px 4px; padding:12px 16px; border-radius:10px;
          background:var(--saffron); color:#fff;
          border:none; cursor:pointer; font-family:'Inter',sans-serif; font-weight:600;
          font-size:0.95rem; display:flex; align-items:center; gap:8px;
          box-shadow:var(--card-shadow);
          -webkit-tap-highlight-color:transparent;
        }
      }
    `}</style>
    {/* ── Mobile history drawer ── */}
    {showDrawer && (
      <>
        <div className="chat-history-overlay" onClick={() => setShowDrawer(false)} />
        <div className="chat-history-drawer">
          <div className="chat-history-drawer-header">
            <span className="chat-history-drawer-title">Conversations</span>
            <button className="drawer-close-btn" onClick={() => setShowDrawer(false)}>✕</button>
          </div>
          <button className="drawer-new-chat-btn" onClick={() => { startNewChat(); setShowDrawer(false); }}>
            ✏️ New Conversation
          </button>
          <div className="sessions-list" style={{flex:1,overflowY:"auto",padding:"10px 8px"}}>
            {sessions.length === 0 && (
              <div style={{padding:"20px 12px",textAlign:"center",color:"var(--text-dim)",fontSize:"1rem"}}>
                Start your first conversation 🙏
              </div>
            )}
            {Object.entries(groups).map(([group, items]) =>
              items.length > 0 ? (
                <div key={group}>
                  <div className="session-group-label">{group}</div>
                  {items.map(s => (
                    <div
                      key={s.session_id}
                      className={`session-item ${activeId === s.session_id ? "active" : ""}`}
                      onClick={() => { openSession(s.session_id); setShowDrawer(false); }}
                    >
                      <span style={{fontSize:"0.85rem"}}>🕉️</span>
                      <span className="session-title">{s.title}</span>
                      <button
                        className="session-delete"
                        onClick={(e) => deleteSession(e, s.session_id)}
                        title="Delete"
                      >✕</button>
                    </div>
                  ))}
                </div>
              ) : null
            )}
          </div>
          <div style={{padding:"12px 16px",borderTop:"1px solid var(--border)",fontSize:"0.95rem",color:"var(--text-dim)",textAlign:"center"}}>
            {sessions.length} conversation{sessions.length !== 1 ? "s" : ""}
          </div>
        </div>
      </>
    )}

    <div className="chat-layout" style={{
      display:"flex",
      height:"calc(100vh - 64px)", overflow:"hidden", width:"100%",
    }}>

      {/* ── Desktop Sidebar ── */}
      {!isMobile && <div className="chat-sidebar" style={{
        width:"260px", minWidth:"260px", flexShrink:0,
        flexDirection:"column", overflow:"hidden",
      }}>
        <div className="chat-sidebar-header">
          <button className="new-chat-btn" onClick={startNewChat}>
            ✏️ New Conversation
          </button>
        </div>

        <div className="sessions-list">
          {sessions.length === 0 && (
            <div style={{padding:"20px 12px",textAlign:"center",color:"var(--text-dim)",fontSize:"1rem"}}>
              Start your first conversation 🙏
            </div>
          )}

          {Object.entries(groups).map(([group, items]) =>
            items.length > 0 ? (
              <div key={group}>
                <div className="session-group-label">{group}</div>
                {items.map(s => (
                  <div
                    key={s.session_id}
                    className={`session-item ${activeId === s.session_id ? "active" : ""}`}
                    onClick={() => openSession(s.session_id)}
                  >
                    <span style={{fontSize:"0.85rem"}}>🕉️</span>
                    <span className="session-title">{s.title}</span>
                    <button
                      className="session-delete"
                      onClick={(e) => deleteSession(e, s.session_id)}
                      title="Delete"
                    >✕</button>
                  </div>
                ))}
              </div>
            ) : null
          )}
        </div>

        <div style={{padding:"12px 16px",borderTop:"1px solid var(--border)",fontSize:"0.95rem",color:"var(--text-dim)",textAlign:"center"}}>
          {sessions.length} conversation{sessions.length !== 1 ? "s" : ""}
        </div>
      </div>}

      {/* ── Main chat area ── */}
      <div className="chat-main" style={{
        flex:1, minWidth:0, display:"flex", flexDirection:"column", overflow:"hidden",
      }}>

        {/* Mobile top bar */}
        <div className="chat-mobile-bar">
          <button className="chat-mob-btn" onClick={() => setShowDrawer(true)}>
            ☰
          </button>
          <span className="chat-mob-title">Ask the Gita</span>
          <button className="chat-mob-btn" onClick={startNewChat} title="New conversation">
            ✏️
          </button>
        </div>

        {/* Desktop header */}
        <div className="chat-main-header">
          <div className="section-title" style={{marginBottom:"4px",fontSize:"1.3rem"}}>
            Ask the Gita
          </div>
          <div className="section-sub" style={{marginBottom:0,fontSize:"0.95rem"}}>
            Wisdom from the Bhagavad Gita — your personal divine companion
          </div>
        </div>

        {/* No session selected */}
        {!activeId && messages.length === 0 ? (
          <div className="empty-chat">
            <div className="empty-om">ॐ</div>
            <div className="empty-title">Namaste, {user.name}</div>
            <div className="empty-sub">
              The Bhagavad Gita has an answer for every weight you carry.
            </div>
            <div style={{fontSize:"1rem",color:"var(--text-dim)",marginBottom:"32px"}}>
              What is on your heart today?
            </div>
            <div className="quick-prompts">
              {QUICK.map((q,i) => (
                <button key={i} className="quick-prompt" onClick={() => sendMessage(q)}>
                  <span className="qp-icon">🙏</span>
                  <span className="qp-text">{q}</span>
                </button>
              ))}
            </div>
          </div>
        ) : (
          <>
            {/* Messages */}
            <div className="chat-messages">
              {loadingHist ? (
                <div style={{textAlign:"center",color:"var(--text-dim)",fontStyle:"italic",padding:"40px"}}>
                  Loading conversation...
                </div>
              ) : (
                messages.map((msg, i) => (
                  <div key={i} className={`msg msg-${msg.role}`}>
                    <div className={`msg-avatar ${msg.role}`}>
                      {msg.role === "ai" ? "ॐ" : user.name[0].toUpperCase()}
                    </div>
                    <div className="msg-content">
                      {msg.role === "ai" && msg.emotion && (
                        <div className="msg-emotion">
                          {EMOTION_ICONS[msg.emotion] || "🕉️"} {msg.emotion}
                        </div>
                      )}
                      <div className="msg-bubble">
                        {(msg.text.includes("\n\n")
  ? msg.text.split("\n\n")
  : msg.text.split(/(?<=[.?!])\s+(?=[A-Z])/)
).map((para, pi, arr) => (
                          <p key={pi} style={{marginBottom: pi < arr.length-1 ? "14px" : 0}}>
                            {para}
                          </p>
                        ))}
                      </div>
                      {msg.time && <div className="msg-time">{msg.time}</div>}

                      {/* Journey suggestion CTA */}
                      {msg.journey_suggestion && !msg.journey_suggestion._dismissed && (
                        <div style={{
                          marginTop: "14px",
                          padding: "14px 16px",
                          borderRadius: "12px",
                          background: "linear-gradient(135deg,rgba(232,131,42,0.1),rgba(201,149,58,0.06))",
                          border: "1px solid rgba(232,131,42,0.3)",
                          display: "flex", alignItems: "center", justifyContent: "space-between",
                          gap: "12px", flexWrap: "wrap",
                          position: "relative",
                        }}>
                          {/* Dismiss */}
                          <button
                            onClick={() => setMessages(prev => prev.map((m, mi) =>
                              mi === i
                                ? { ...m, journey_suggestion: { ...m.journey_suggestion, _dismissed: true } }
                                : m
                            ))}
                            style={{
                              position: "absolute", top: "8px", right: "8px",
                              background: "none", border: "none", cursor: "pointer",
                              color: "var(--text-dim)", fontSize: "0.9rem", lineHeight: "1",
                              padding: "2px 6px", borderRadius: "4px",
                            }}
                            title="Dismiss"
                          >✕</button>

                          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <span style={{ fontSize: "1.6rem", flexShrink: 0 }}>{msg.journey_suggestion.icon}</span>
                            <div>
                              <div style={{ fontFamily: "'Crimson Pro',serif", fontSize: "1rem", color: "var(--text)", lineHeight: "1.3" }}>
                                Ready to go deeper?
                              </div>
                              <div style={{ fontSize: "0.85rem", color: "var(--text-dim)", marginTop: "2px" }}>
                                21-day <strong style={{ color: "var(--saffron)" }}>{msg.journey_suggestion.title}</strong> journey — {msg.journey_suggestion.subtitle}
                              </div>
                            </div>
                          </div>
                          <button
                            onClick={() => onNavigate?.("journey")}
                            style={{
                              padding: "8px 18px", borderRadius: "8px", cursor: "pointer",
                              background: "rgba(232,131,42,0.15)", border: "1px solid var(--saffron)",
                              color: "var(--saffron)", fontFamily: "'Crimson Pro',serif",
                              fontSize: "0.95rem", whiteSpace: "nowrap", flexShrink: 0,
                              transition: "all 0.2s",
                            }}
                          >
                            Start Journey →
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                ))
              )}

              {loading && (
                <div className="msg msg-ai">
                  <div className="msg-avatar ai">ॐ</div>
                  <div className="msg-content">
                    <div className="msg-emotion">🕉️ reflecting...</div>
                    <div className="typing-indicator">
                      <div className="typing-dot"/>
                      <div className="typing-dot"/>
                      <div className="typing-dot"/>
                    </div>
                  </div>
                </div>
              )}
              <div ref={bottomRef}/>
            </div>

            {/* Input */}
            <div className="chat-input-area">
              <div className="chat-input-row">
                <textarea
                  ref={inputRef}
                  className="chat-input"
                  placeholder="What weighs on your heart today?"
                  value={input}
                  rows={1}
                  onChange={e => {
                    setInput(e.target.value);
                    e.target.style.height = "auto";
                    e.target.style.height = Math.min(e.target.scrollHeight, 120) + "px";
                  }}
                  onKeyDown={handleKey}
                />
              </div>
              <button
                className="send-btn"
                onClick={() => sendMessage()}
                disabled={loading || !input.trim()}
              >🙏</button>
            </div>
          </>
        )}
      </div>
    </div>
    </>
  );
}




// ══════════════════════════════════════════════════════════════════════════════
// TELUGU QUALITY REVIEW PAGE
// ══════════════════════════════════════════════════════════════════════════════

function TeluguReviewPage() {
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [filter,  setFilter]  = useState("all"); // "all" | "cached" | "missing"
  const [expand,  setExpand]  = useState({});

  useEffect(() => {
    fetch(`${API}/shloka/cache-review`)
      .then(r => r.json())
      .then(d => { setData(d); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  const toggle = (key) => setExpand(prev => ({ ...prev, [key]: !prev[key] }));

  if (loading) return (
    <div className="page">
      <div style={{color:"var(--text-dim)",fontStyle:"italic",padding:"40px 0",textAlign:"center"}}>
        Loading cache review...
      </div>
    </div>
  );

  if (!data || data.error) return (
    <div className="page">
      <div className="section-title">Telugu Quality Review</div>
      <div style={{color:"#ff8080",padding:"20px",background:"rgba(220,50,50,0.1)",borderRadius:"var(--radius)",border:"1px solid rgba(220,50,50,0.3)"}}>
        {data?.error || "Backend not running. Start with: uvicorn api:app --reload --port 8000"}
      </div>
    </div>
  );

  const verses = (data.verses || []).filter(v => {
    if (filter === "cached")  return v.cached;
    if (filter === "missing") return !v.cached;
    return true;
  });

  return (
    <div className="page" style={{maxWidth:"1100px"}}>
      <div className="section-title">Telugu Quality Review</div>
      <div className="section-sub">తెలుగు నాణ్యత సమీక్ష — Compare English originals with Llama 8B translations</div>

      {/* Stats bar */}
      <div style={{
        display:"flex", gap:"16px", marginBottom:"20px", flexWrap:"wrap",
      }}>
        {[
          { label:"Total Verses",   val: data.total,                           color:"var(--text-dim)" },
          { label:"Cached Telugu",  val: data.cached_count,                    color:"#4ade80" },
          { label:"Not Cached Yet", val: data.total - data.cached_count,       color:"#fb923c" },
          { label:"Coverage",       val: Math.round(data.cached_count / Math.max(data.total,1)*100)+"%", color:"var(--saffron)" },
        ].map(s => (
          <div key={s.label} style={{
            background:"var(--bg2)", border:"1px solid var(--border)",
            borderRadius:"var(--radius)", padding:"14px 20px", minWidth:"130px",
          }}>
            <div style={{fontSize:"1.5rem",fontFamily:"'Cinzel Decorative',serif",color:s.color}}>{s.val}</div>
            <div style={{fontSize:"0.75rem",color:"var(--text-dim)",marginTop:"4px"}}>{s.label}</div>
          </div>
        ))}
      </div>

      {/* Filter buttons */}
      <div style={{display:"flex",gap:"8px",marginBottom:"20px"}}>
        {[["all","All Verses"],["cached","Cached Only"],["missing","Not Cached"]].map(([f,label]) => (
          <button key={f} onClick={() => setFilter(f)} style={{
            padding:"6px 16px", borderRadius:"20px", cursor:"pointer",
            fontFamily:"'Crimson Pro',serif", fontSize:"0.88rem",
            background: filter === f ? "var(--saffron)" : "transparent",
            color:      filter === f ? "white" : "var(--text-dim)",
            border:     filter === f ? "1px solid var(--saffron)" : "1px solid var(--border)",
          }}>{label}</button>
        ))}
      </div>

      {/* Verse cards */}
      <div style={{display:"flex", flexDirection:"column", gap:"12px"}}>
        {verses.map(v => {
          const key = `${v.chapter}_${v.verse}`;
          const isOpen = expand[key];
          const hasComm = v.te_story || v.te_artha || v.te_reflection;
          return (
            <div key={key} style={{
              background:"var(--bg2)", border:"1px solid var(--border)",
              borderRadius:"var(--radius)", overflow:"hidden",
              borderLeft: `3px solid ${v.cached ? "#4ade80" : "rgba(251,146,60,0.5)"}`,
            }}>
              {/* Header row */}
              <div
                onClick={() => toggle(key)}
                style={{
                  display:"flex", alignItems:"center", gap:"12px",
                  padding:"14px 20px", cursor:"pointer",
                }}
              >
                <span style={{
                  fontFamily:"'Cinzel Decorative',serif", fontSize:"0.82rem",
                  color:"var(--saffron)", minWidth:"80px",
                }}>BG {v.chapter}.{v.verse}</span>
                <span style={{
                  fontSize:"0.78rem", padding:"2px 8px", borderRadius:"10px",
                  background: v.cached ? "rgba(74,222,128,0.12)" : "rgba(251,146,60,0.12)",
                  color:      v.cached ? "#4ade80" : "#fb923c",
                  border:     `1px solid ${v.cached ? "rgba(74,222,128,0.3)" : "rgba(251,146,60,0.3)"}`,
                  flexShrink:0,
                }}>
                  {v.cached ? "✓ Cached" : "○ Missing"}
                </span>
                {hasComm && <span style={{fontSize:"0.75rem",color:"var(--text-dim)",flexShrink:0}}>+ commentary</span>}
                <span style={{
                  flex:1, fontSize:"0.9rem", color:"var(--text-dim)",
                  overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap",
                }}>
                  {v.en_meaning.slice(0,90)}{v.en_meaning.length > 90 ? "…" : ""}
                </span>
                <span style={{color:"var(--text-dim)",fontSize:"0.8rem",flexShrink:0}}>
                  {isOpen ? "▲" : "▼"}
                </span>
              </div>

              {/* Expanded content */}
              {isOpen && (
                <div style={{borderTop:"1px solid var(--border)", padding:"20px"}}>
                  {/* English vs Telugu side by side */}
                  <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:"16px", marginBottom: hasComm ? "16px" : 0}}>
                    <div>
                      <div style={{fontSize:"0.72rem",color:"var(--text-dim)",letterSpacing:"0.1em",textTransform:"uppercase",marginBottom:"8px"}}>
                        English (Original)
                      </div>
                      <div style={{fontSize:"0.95rem",lineHeight:"1.7",color:"var(--text)"}}>
                        {v.en_meaning}
                      </div>
                    </div>
                    <div>
                      <div style={{fontSize:"0.72rem",color:"var(--saffron)",letterSpacing:"0.1em",textTransform:"uppercase",marginBottom:"8px"}}>
                        తెలుగు (Telugu — Llama 8B)
                      </div>
                      {v.te_meaning ? (
                        <div style={{fontSize:"1rem",lineHeight:"1.8",color:"var(--cream)",whiteSpace:"pre-line"}}>
                          {v.te_meaning}
                        </div>
                      ) : (
                        <div style={{fontSize:"0.9rem",color:"var(--text-dim)",fontStyle:"italic"}}>
                          Not generated yet
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Commentary sections */}
                  {hasComm && (
                    <div style={{
                      marginTop:"16px", borderTop:"1px solid var(--border)",
                      paddingTop:"16px", display:"flex", flexDirection:"column", gap:"12px",
                    }}>
                      <div style={{fontSize:"0.72rem",color:"var(--saffron)",letterSpacing:"0.1em",textTransform:"uppercase"}}>
                        Commentary (తెలుగు)
                      </div>
                      {[["Prasanga · Context", v.te_story],["Artha · Meaning", v.te_artha],["Chintan · Reflection", v.te_reflection]].map(([label, val]) =>
                        val ? (
                          <div key={label} style={{
                            background:"var(--bg3)", borderRadius:"8px",
                            padding:"12px 16px", borderLeft:"2px solid var(--saffron)",
                          }}>
                            <div style={{fontSize:"0.72rem",color:"var(--text-dim)",marginBottom:"6px"}}>{label}</div>
                            <div style={{fontSize:"0.95rem",lineHeight:"1.7",color:"var(--text)",whiteSpace:"pre-line"}}>{val}</div>
                          </div>
                        ) : null
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}


// ══════════════════════════════════════════════════════════════════════════════
// JOURNAL PAGE
// ══════════════════════════════════════════════════════════════════════════════

function JournalPage() {
  const [entries, setEntries] = useState(MOCK_JOURNAL);
  const [newText, setNewText] = useState("");

  const addEntry = () => {
    if (!newText.trim()) return;
    setEntries(prev => [{
      id: Date.now(),
      date: new Date().toLocaleDateString("en-US",{month:"long",day:"numeric",year:"numeric"}),
      text: newText.trim(),
      verse: "BG 2.47 — Your duty today",
    }, ...prev]);
    setNewText("");
  };

  return (
    <div className="page">
      <div className="section-title">Spiritual Journal</div>
      <div className="section-sub">Record your reflections — let the Gita respond</div>
      <textarea className="journal-new" placeholder="Write your thoughts, questions, or reflections today..."
        value={newText} onChange={e => setNewText(e.target.value)} />
      <div style={{display:"flex",gap:"10px",marginBottom:"28px"}}>
        <button className="btn" onClick={addEntry}>Save Reflection 🙏</button>
        <button className="btn btn-outline">Ask Gita to respond</button>
      </div>
      <div className="journal-list">
        {entries.map(entry => (
          <div key={entry.id} className="journal-entry">
            <div className="journal-date">{entry.date}</div>
            <div className="journal-text">{entry.text}</div>
            {entry.verse && <div className="journal-verse">🕉 {entry.verse}</div>}
          </div>
        ))}
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// PROFILE PAGE
// ══════════════════════════════════════════════════════════════════════════════

const SCORE_LABELS_PROFILE = ["", "Still heavy", "A little lighter", "Steadier", "Much clearer", "At peace"];

function ProfilePage({ user, onLogout, onOpenShloka, preferredLang, onLangChange, onUserUpdate }) {
  const [summary,      setSummary]      = useState(null);
  const [loading,      setLoading]      = useState(true);
  const [bookmarks,    setBookmarks]    = useState([]);
  const [langSaving,   setLangSaving]   = useState(false);
  const [photoUploading, setPhotoUploading] = useState(false);
  const [photoError,   setPhotoError]   = useState("");
  const [contentFocus, setContentFocus] = useState("both");
  const [focusSaving,  setFocusSaving]  = useState(false);

  useEffect(() => {
    fetch(`${API}/profile/journey-summary/${encodeURIComponent(user.id)}`)
      .then(r => r.json())
      .then(d => { setSummary(d); setLoading(false); })
      .catch(() => setLoading(false));

    fetch(`${API}/bookmarks/${encodeURIComponent(user.id)}`)
      .then(r => r.json())
      .then(d => setBookmarks(d.bookmarks || []))
      .catch(() => {});

    fetch(`${API}/user/content-focus/${encodeURIComponent(user.id)}`)
      .then(r => r.json())
      .then(d => setContentFocus(d.content_focus || "both"))
      .catch(() => {});
  }, [user.id]);

  const removeBookmark = async (chapter, verse) => {
    await fetch(`${API}/bookmark/${encodeURIComponent(user.id)}/${chapter}/${verse}`, { method: "DELETE" });
    setBookmarks(prev => prev.filter(b => !(b.chapter === chapter && b.verse === verse)));
  };

  const handlePhotoUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) { setPhotoError("Please select an image file"); return; }
    setPhotoError("");
    setPhotoUploading(true);
    try {
      // Resize + crop to 150×150 square in browser
      const dataUrl = await new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = 150; canvas.height = 150;
          const ctx = canvas.getContext("2d");
          const size = Math.min(img.width, img.height);
          const sx = (img.width  - size) / 2;
          const sy = (img.height - size) / 2;
          ctx.drawImage(img, sx, sy, size, size, 0, 0, 150, 150);
          resolve(canvas.toDataURL("image/jpeg", 0.82));
        };
        img.onerror = reject;
        img.src = URL.createObjectURL(file);
      });
      // Save to our own backend (SQLite) — no Supabase Storage needed
      const res = await fetch(`${API}/user/avatar`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_id: user.id, photo_data: dataUrl }),
      });
      if (!res.ok) throw new Error("Backend save failed");
      onUserUpdate?.({ photo: dataUrl });
    } catch (err) {
      setPhotoError("Could not save photo. Please try again.");
    }
    setPhotoUploading(false);
  };

  const handleLogout = async () => {
    try { localStorage.removeItem("vs_dev_login"); } catch {}
    try { await supabase.auth.signOut(); } catch {}
    onLogout();
  };

  const handleLangSelect = async (code) => {
    if (langSaving) return;
    setLangSaving(true);
    try {
      await fetch(`${API}/user/language?user_id=${encodeURIComponent(user.id)}&lang_code=${code}`, { method: "POST" });
      onLangChange?.(code);
    } catch {}
    setLangSaving(false);
  };

  const handleFocusSelect = async (focus) => {
    if (focusSaving || focus === contentFocus) return;
    setFocusSaving(true);
    try {
      await fetch(`${API}/user/content-focus?user_id=${encodeURIComponent(user.id)}&focus=${focus}`, { method: "POST" });
      setContentFocus(focus);
    } catch {}
    setFocusSaving(false);
  };

  const initials = user.name ? user.name[0].toUpperCase() : "?";

  // Active journey progress bar
  const ActiveJourneyCard = ({ j }) => {
    const pct = Math.round(((j.current_day - 1) / 21) * 100);
    const phase = j.current_day <= 7 ? "Awareness" : j.current_day <= 14 ? "Understanding" : "Transformation";
    return (
      <div style={{
        background: "linear-gradient(135deg,rgba(232,131,42,0.08),rgba(201,149,58,0.04))",
        border: "1px solid rgba(232,131,42,0.35)", borderRadius: "14px",
        padding: "24px 28px", marginBottom: "20px",
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "16px" }}>
          <span style={{ fontSize: "2rem" }}>{j.icon}</span>
          <div>
            <div style={{ fontFamily: "'Inter',sans-serif", fontWeight: 700, fontSize: "1rem", color: "var(--saffron)" }}>
              {j.title}
            </div>
            <div style={{ fontSize: "0.95rem", color: "var(--text-dim)", marginTop: "2px" }}>
              Day {j.current_day - 1} of 21 · Phase: {phase}
            </div>
          </div>
          <div style={{
            marginLeft: "auto", fontFamily: "'Inter',sans-serif", fontWeight: 700,
            fontSize: "1.5rem", color: "#a16207",
          }}>
            {pct}%
          </div>
        </div>
        {/* Progress bar */}
        <div style={{ height: "6px", background: "var(--bg3)", borderRadius: "3px", overflow: "hidden" }}>
          <div style={{
            height: "100%", width: `${pct}%`,
            background: "linear-gradient(90deg,var(--saffron),var(--gold))",
            borderRadius: "3px", transition: "width 0.6s ease",
          }} />
        </div>
        {/* Day dots — first 21 */}
        <div style={{ display: "flex", gap: "4px", marginTop: "10px", flexWrap: "wrap" }}>
          {Array.from({ length: 21 }, (_, i) => (
            <div key={i} style={{
              width: "10px", height: "10px", borderRadius: "50%",
              background: i < j.current_day - 1
                ? "linear-gradient(135deg,var(--saffron),var(--gold))"
                : i === j.current_day - 1
                  ? "rgba(232,131,42,0.4)"
                  : "var(--bg3)",
              border: i === j.current_day - 1 ? "1px solid var(--saffron)" : "none",
            }} />
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="page" style={{ maxWidth: "720px" }}>
      <div className="section-title">Your Profile</div>
      <div className="section-sub">Your transformation with Vedsanga</div>

      {/* ── Identity card ── */}
      <div className="profile-card" style={{ display: "flex", alignItems: "center", gap: "24px", flexWrap: "wrap" }}>
        <div style={{ position: "relative", flexShrink: 0 }}>
          {user.photo ? (
            <img src={user.photo} alt={user.name} referrerPolicy="no-referrer"
              style={{ width: 72, height: 72, borderRadius: "50%", objectFit: "cover", border: "2px solid var(--saffron)" }} />
          ) : (
            <div className="profile-avatar-lg" style={{ margin: 0 }}>{initials}</div>
          )}
          {/* Upload button */}
          <label style={{
            position: "absolute", bottom: 0, right: 0,
            width: 24, height: 24, borderRadius: "50%",
            background: "var(--saffron)", cursor: "pointer",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: "0.75rem", color: "white", border: "2px solid var(--bg)",
          }} title="Change photo">
            {photoUploading ? "…" : "↑"}
            <input type="file" accept="image/*" onChange={handlePhotoUpload}
              style={{ display: "none" }} disabled={photoUploading} />
          </label>
        </div>
        <div style={{ flex: 1 }}>
          <div className="profile-name">{user.name}</div>
          <div className="profile-since">{user.email}</div>
          <div style={{ fontSize: "0.95rem", color: "var(--text-dim)", marginTop: "4px" }}>
            Seeker on Vedsanga
          </div>
          {photoError && (
            <div style={{ fontSize: "0.95rem", color: "#b91c1c", marginTop: "6px" }}>{photoError}</div>
          )}
        </div>
        <button className="btn btn-outline" onClick={handleLogout} style={{ alignSelf: "flex-start" }}>
          Sign out
        </button>
      </div>

      {loading ? (
        <div style={{ textAlign: "center", color: "var(--text-dim)", padding: "40px" }}>
          Loading your journey...
        </div>
      ) : summary ? (
        <>
          {/* ── Stats row ── */}
          <div className="stats-row" style={{ marginBottom: "20px" }}>
            {[
              { num: summary.total_days_completed,   label: "Days Completed" },
              { num: summary.total_conversations,    label: "Conversations" },
              { num: summary.avg_score > 0 ? `${summary.avg_score}/5` : "—", label: "Avg Inner Score" },
              { num: summary.score_trend > 0 ? `+${summary.score_trend}` : summary.score_trend || "—", label: "Score Shift" },
            ].map((s, i) => (
              <div key={i} className="stat-box" style={{ flex: 1 }}>
                <div className="stat-num" style={{
                  color: i === 3 && summary.score_trend > 0 ? "#15803d"
                       : i === 3 && summary.score_trend < 0 ? "#b91c1c"
                       : "var(--saffron)"
                }}>{s.num}</div>
                <div className="stat-label">{s.label}</div>
              </div>
            ))}
          </div>

          {/* ── Active journey ── */}
          {summary.active_journey ? (
            <>
              <div style={{
                fontFamily: "'Inter',sans-serif", fontWeight: 700, fontSize: "1.05rem",
                color: "#a16207", marginBottom: "12px",
              }}>
                Active Journey
              </div>
              <ActiveJourneyCard j={summary.active_journey} />
            </>
          ) : (
            <div style={{
              background: "var(--bg2)", border: "1px dashed var(--border)",
              borderRadius: "12px", padding: "24px", textAlign: "center",
              marginBottom: "20px", color: "var(--text-dim)",
            }}>
              No active journey. Start one from the 21-Day Journey page.
            </div>
          )}

          {/* ── Emotion arc ── */}
          {summary.emotion_arc && summary.emotion_arc.length > 0 && (
            <div className="profile-card" style={{ marginBottom: "20px" }}>
              <div style={{
                fontFamily: "'Inter',sans-serif", fontWeight: 700, fontSize: "1.05rem",
                color: "#a16207", marginBottom: "16px",
              }}>
                How You Arrived Each Day
              </div>
              <div style={{ fontSize: "0.95rem", color: "var(--text-dim)", marginBottom: "16px" }}>
                The emotion you felt before reading each day's verse
              </div>
              {(() => {
                const maxCount = Math.max(...summary.emotion_arc.map(e => e.count));
                return summary.emotion_arc.map((e, i) => (
                  <div key={i} style={{ marginBottom: "12px" }}>
                    <div style={{
                      display: "flex", justifyContent: "space-between",
                      marginBottom: "5px", fontSize: "0.95rem", color: "var(--text)",
                    }}>
                      <span>{e.emotion}</span>
                      <span style={{ color: "var(--text-dim)", fontSize: "0.95rem" }}>
                        {e.count} {e.count === 1 ? "day" : "days"}
                      </span>
                    </div>
                    <div style={{ height: "5px", background: "var(--bg3)", borderRadius: "3px" }}>
                      <div style={{
                        height: "100%",
                        width: `${Math.round((e.count / maxCount) * 100)}%`,
                        background: "linear-gradient(90deg,var(--saffron),var(--gold))",
                        borderRadius: "3px", transition: "width 0.5s ease",
                      }} />
                    </div>
                  </div>
                ));
              })()}
            </div>
          )}

          {/* ── Past journeys ── */}
          {summary.past_journeys && summary.past_journeys.length > 0 && (
            <div className="profile-card">
              <div style={{
                fontFamily: "'Inter',sans-serif", fontWeight: 700, fontSize: "1.05rem",
                color: "#a16207", marginBottom: "16px",
              }}>
                Past Journeys
              </div>
              {summary.past_journeys.map((j, i) => (
                <div key={i} style={{
                  display: "flex", alignItems: "center", gap: "12px",
                  padding: "12px 0",
                  borderBottom: i < summary.past_journeys.length - 1 ? "1px solid var(--border)" : "none",
                }}>
                  <span style={{ fontSize: "1.5rem" }}>{j.icon}</span>
                  <div style={{ flex: 1 }}>
                    <div style={{ color: "var(--cream)", fontSize: "0.98rem" }}>{j.title}</div>
                    <div style={{ color: "var(--text-dim)", fontSize: "0.95rem", marginTop: "2px" }}>
                      {j.days_done} days completed
                    </div>
                  </div>
                  <div style={{
                    fontSize: "0.92rem", padding: "4px 10px", borderRadius: "20px",
                    background: j.completed ? "rgba(21,128,61,0.08)" : "var(--bg3)",
                    color: j.completed ? "#15803d" : "var(--text-dim)",
                    border: j.completed ? "1px solid rgba(21,128,61,0.3)" : "1px solid var(--border)",
                  }}>
                    {j.completed ? "Completed ✓" : "Paused"}
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      ) : (
        <div style={{ color: "var(--text-dim)" }}>
          Could not load journey data.
        </div>
      )}

      {/* ── Saved Verses ── */}
      {bookmarks.length > 0 && (
        <div className="profile-card" style={{ marginTop: "20px" }}>
          <div style={{
            fontFamily: "'Inter',sans-serif", fontWeight: 700, fontSize: "1.05rem",
            color: "#a16207", marginBottom: "16px",
            display: "flex", alignItems: "center", justifyContent: "space-between",
          }}>
            <span>🔖 Saved Verses</span>
            <span style={{ fontSize: "0.92rem", color: "var(--text-dim)", fontFamily: "inherit", fontWeight: 400 }}>
              {bookmarks.length} verse{bookmarks.length !== 1 ? "s" : ""}
            </span>
          </div>
          {bookmarks.map((b, i) => (
            <div key={i} style={{
              padding: "14px 0",
              borderBottom: i < bookmarks.length - 1 ? "1px solid var(--border)" : "none",
              display: "flex", alignItems: "flex-start", gap: "12px",
            }}>
              {/* Clickable area */}
              <div
                onClick={() => onOpenShloka?.({ chapter: b.chapter, verse: b.verse })}
                style={{ display: "flex", alignItems: "flex-start", gap: "12px", flex: 1, minWidth: 0, cursor: "pointer" }}
              >
                <div style={{
                  background: "rgba(232,131,42,0.1)", border: "1px solid var(--border)",
                  borderRadius: "8px", padding: "8px 12px", textAlign: "center", flexShrink: 0,
                  minWidth: "64px",
                }}>
                  <div style={{ fontFamily: "'Inter',sans-serif", fontWeight: 700, fontSize: "0.95rem", color: "var(--saffron)" }}>
                    BG {b.chapter}.{b.verse}
                  </div>
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  {b.meaning && (
                    <div style={{
                      fontSize: "0.98rem", color: "var(--text)", lineHeight: "1.6",
                      display: "-webkit-box", WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical", overflow: "hidden",
                    }}>
                      {b.meaning}
                    </div>
                  )}
                  <div style={{ fontSize: "0.92rem", color: "var(--text-dim)", marginTop: "4px" }}>
                    Saved {new Date(b.saved_at).toLocaleDateString()} · Tap to read →
                  </div>
                </div>
              </div>
              <button
                onClick={() => removeBookmark(b.chapter, b.verse)}
                title="Remove bookmark"
                style={{
                  background: "none", border: "none", cursor: "pointer",
                  color: "var(--text-dim)", fontSize: "1rem", padding: "4px", flexShrink: 0,
                }}
              >✕</button>
            </div>
          ))}
        </div>
      )}

      {/* ── Language Preference ── */}
      <div className="profile-card" style={{ marginTop: "20px" }}>
        <div style={{
          fontFamily: "'Inter',sans-serif", fontWeight: 700, fontSize: "1.05rem",
          color: "#a16207", marginBottom: "8px",
        }}>
          🌐 Preferred Language
        </div>
        <div style={{ fontSize: "0.95rem", color: "var(--text-dim)", marginBottom: "16px" }}>
          Verses and commentary will auto-translate to your language on the Shloka page.
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
          {LANG_OPTIONS.map(l => (
            <button
              key={l.code}
              onClick={() => handleLangSelect(l.code)}
              disabled={langSaving}
              style={{
                padding: "6px 14px", borderRadius: "20px",
                background: preferredLang === l.code ? "var(--saffron)" : "transparent",
                color:      preferredLang === l.code ? "white" : "var(--text-dim)",
                border:     preferredLang === l.code ? "1px solid var(--saffron)" : "1px solid var(--border)",
                fontFamily: "'Inter',sans-serif", fontSize: "0.95rem",
                cursor: langSaving ? "not-allowed" : "pointer",
                transition: "all 0.15s",
              }}
            >
              {l.native}
            </button>
          ))}
        </div>
      </div>

      {/* ── Home Page Content ── */}
      <div className="profile-card" style={{ marginTop: "20px" }}>
        <div style={{
          fontFamily: "'Inter',sans-serif", fontWeight: 700, fontSize: "1.05rem",
          color: "#a16207", marginBottom: "8px",
        }}>
          🏠 Home Page Content
        </div>
        <div style={{ fontSize: "0.95rem", color: "var(--text-dim)", marginBottom: "16px" }}>
          Choose what shows on your home page.
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
          {[
            { code: "gita", label: "Gita only" },
            { code: "both", label: "Gita + Astrology" },
          ].map(o => (
            <button
              key={o.code}
              onClick={() => handleFocusSelect(o.code)}
              disabled={focusSaving}
              style={{
                padding: "6px 14px", borderRadius: "20px",
                background: contentFocus === o.code ? "var(--saffron)" : "transparent",
                color:      contentFocus === o.code ? "white" : "var(--text-dim)",
                border:     contentFocus === o.code ? "1px solid var(--saffron)" : "1px solid var(--border)",
                fontFamily: "'Inter',sans-serif", fontSize: "0.95rem",
                cursor: focusSaving ? "not-allowed" : "pointer",
                transition: "all 0.15s",
              }}
            >
              {o.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// MAIN APP
// ══════════════════════════════════════════════════════════════════════════════

// ── Today Hub Page ───────────────────────────────────────────────────────────
function TodayPage({ user, onNavigate, streak }) {
  const [shloka,   setShloka]   = useState(null);
  const [panchang, setPanchang] = useState(null);
  const [journey,  setJourney]  = useState(null);

  useEffect(() => {
    fetch(`${API}/shloka/today`).then(r => r.json()).then(setShloka).catch(() => {});
    fetch(`${API}/panchang/today`).then(r => r.json()).then(setPanchang).catch(() => {});
    if (user?.id) {
      fetch(`${API}/journey/today/${encodeURIComponent(user.id)}`).then(r => r.json()).then(setJourney).catch(() => {});
    }
  }, [user?.id]);

  const greeting = () => {
    const h = new Date().getHours();
    if (h < 5)  return "Good Night";
    if (h < 12) return "Good Morning";
    if (h < 17) return "Good Afternoon";
    if (h < 21) return "Good Evening";
    return "Good Night";
  };

  const HubCard = ({ icon, title, sub, color, accent, onClick, children }) => (
    <div onClick={onClick} style={{
      background: "#FFFFFF",
      border: `1px solid ${color}30`,
      borderLeft: `4px solid ${color}`,
      borderRadius: 16,
      padding: "18px 20px",
      marginBottom: 14,
      cursor: "pointer",
      boxShadow: `0 2px 14px ${color}14`,
      transition: "transform 0.15s, box-shadow 0.15s",
      position: "relative",
      overflow: "hidden",
    }}
      onTouchStart={e => { e.currentTarget.style.transform = "scale(0.985)"; }}
      onTouchEnd={e   => { e.currentTarget.style.transform = "scale(1)"; }}
    >
      <div style={{ display:"flex", alignItems:"flex-start", gap:12 }}>
        <div style={{
          width:44, height:44, borderRadius:12, flexShrink:0,
          background:`${color}14`, border:`1px solid ${color}30`,
          display:"flex", alignItems:"center", justifyContent:"center",
          fontSize:"1.4rem",
        }}>{icon}</div>
        <div style={{ flex:1, minWidth:0 }}>
          <div style={{ fontFamily:"'Cinzel',serif", fontSize:"0.72rem", color, letterSpacing:"0.18em", textTransform:"uppercase", fontWeight:700, marginBottom:3 }}>{title}</div>
          {sub && <div style={{ fontSize:"0.85rem", color:"#888", fontStyle:"italic", marginBottom: children ? 8 : 0 }}>{sub}</div>}
          {children}
        </div>
        <div style={{ color, opacity:0.4, fontSize:"1.2rem", flexShrink:0, alignSelf:"center" }}>›</div>
      </div>
    </div>
  );

  const dateStr = new Date().toLocaleDateString("en-IN", { weekday:"long", day:"numeric", month:"long" });

  return (
    <div className="page" style={{ maxWidth:600, paddingTop:16 }}>
      {/* Greeting header */}
      <div style={{ marginBottom:22 }}>
        <div style={{ fontFamily:"'Cinzel',serif", fontSize:"0.75rem", color:"#9a6010", letterSpacing:"0.2em", textTransform:"uppercase", fontWeight:700, marginBottom:4 }}>{dateStr}</div>
        <div style={{ fontFamily:"'Cinzel Decorative',serif", fontSize:"1.45rem", color:"#2a1200", lineHeight:1.2 }}>
          {greeting()}, {user?.name?.split(" ")[0] || "Seeker"}
        </div>
        <div style={{ fontFamily:"'Crimson Pro',serif", fontSize:"1rem", color:"#7a4010", fontStyle:"italic", marginTop:4 }}>
          Your daily spiritual practice awaits
        </div>
      </div>

      {/* Daily Shloka */}
      <HubCard
        icon="🕉" title="Daily Shloka" color="#C87010"
        sub={shloka ? `Bhagavad Gita · Ch ${shloka.chapter}, Verse ${shloka.verse}` : "Today's sacred verse"}
        onClick={() => onNavigate("shloka")}
      >
        {shloka?.sanskrit && (
          <div style={{ fontFamily:"'Noto Sans Devanagari',serif", fontSize:"0.92rem", color:"#C87010", lineHeight:1.6, opacity:0.85 }}>
            {shloka.sanskrit.length > 80 ? shloka.sanskrit.slice(0, 80) + "…" : shloka.sanskrit}
          </div>
        )}
      </HubCard>

      {/* Panchang */}
      <HubCard
        icon="📅" title="Panchang" color="#9a5010"
        sub="Today's auspicious timings"
        onClick={() => onNavigate("panchang")}
      >
        {panchang?.tithi && (
          <div style={{ fontSize:"0.88rem", color:"#5a3010", lineHeight:1.6 }}>
            {panchang.tithi.name_en && <span>Tithi: <strong>{panchang.tithi.name_en}</strong></span>}
            {panchang.nakshatra?.name_en && <span style={{ marginLeft:12 }}>Nakshatra: <strong>{panchang.nakshatra.name_en}</strong></span>}
          </div>
        )}
      </HubCard>

      {/* Daily Puja */}
      <HubCard
        icon="🪔" title="Daily Puja" color="#C05010"
        sub="Light a diya · Offer aarti · Chant mantras"
        onClick={() => onNavigate("daily-puja")}
      />

      {/* 21-Day Journey */}
      <HubCard
        icon="🌟" title="21-Day Journey" color="#1A4A2E"
        sub={journey?.current_day ? `Day ${journey.current_day} · Your transformation path` : "Your 21-day spiritual journey"}
        onClick={() => onNavigate("journey")}
      >
        {streak > 0 && (
          <div style={{ display:"inline-flex", alignItems:"center", gap:6, background:"rgba(255,100,30,0.1)", border:"1px solid rgba(255,100,30,0.25)", borderRadius:20, padding:"3px 10px", marginTop:4 }}>
            <span style={{ fontSize:"0.85rem" }}>🔥</span>
            <span style={{ fontFamily:"'Cinzel',serif", fontSize:"0.7rem", color:"#cc4010", fontWeight:700, letterSpacing:"0.1em" }}>{streak} DAY STREAK</span>
          </div>
        )}
      </HubCard>

      {/* Ask the Gita */}
      <HubCard
        icon="💬" title="Ask the Gita" color="#2D1B69"
        sub="Talk to your spiritual companion"
        onClick={() => onNavigate("chat")}
      />
    </div>
  );
}

// ── Sacred Texts Hub (merged Gita + Ramayana clubs) ───────────────────────────
function SacredTextsPage({ user }) {
  const [tab, setTab] = useState("gita");
  const tabStyle = (active) => ({
    flex:1, padding:"14px 8px", border:"none", background:"none",
    fontFamily:"'Inter',sans-serif", fontSize:"1rem",
    fontWeight:700, cursor:"pointer",
    color: active ? "var(--saffron)" : "var(--text-dim)",
    borderBottom: active ? "3px solid var(--saffron)" : "3px solid transparent",
    transition:"all 0.2s",
  });
  return (
    <div style={{ display:"flex", flexDirection:"column", flex:1 }}>
      <div style={{ display:"flex", borderBottom:"1px solid var(--border)", background:"#fff", position:"sticky", top:0, zIndex:10 }}>
        <button style={tabStyle(tab==="gita")}     onClick={() => setTab("gita")}>📚 Gita Club</button>
        <button style={tabStyle(tab==="ramayana")} onClick={() => setTab("ramayana")}>🏹 Ramayana</button>
      </div>
      {tab === "gita"     && <BookClubPage user={user} />}
      {tab === "ramayana" && <RamayanaClubPage user={user} />}
    </div>
  );
}

const NAV = [
  {id:"home",          icon:"🏠", label:"Home"},
  {id:"chat",          icon:"💬", label:"Ask the Gita",       group:"practice"},
  {id:"journey",       icon:"🌟", label:"21-Day Journey",     group:"practice"},
  {id:"jyotish",       icon:"⭐", label:"Jyotish · Astrology", group:"practice"},
  {id:"consult",       icon:"🧑‍🏫", label:"Talk to an Astrologer", group:"practice"},
  {id:"family-reports", icon:"💑", label:"Milan & Baby Names", group:"practice"},
  {id:"shloka",        icon:"📿", label:"Daily Shloka",       group:"practice"},
  {id:"browse",        icon:"📖", label:"Browse by Theme",    group:"practice"},
  {id:"sacredtexts",   icon:"📚", label:"Sacred Texts",       group:"practice"},
  {id:"satsang",       icon:"🕉️", label:"Satsang Circles",   group:"practice"},
  {id:"puja",          icon:"🪔", label:"Book a Puja",        group:"practice"},
  {id:"panchang",      icon:"📅", label:"Panchang",           group:"practice"},
  {id:"journal",       icon:"✍️", label:"Spiritual Journal",  group:"tools"},
  {id:"profile",       icon:"👤", label:"My Profile",         group:"tools"},
];

const PAGE_TITLES = {
  home:"Home",
  today:"Today",
  journey:"21-Day Transformation Journey",
  sacredtexts:"Sacred Texts",
  "daily-puja":"Daily Puja",
  shloka:"Daily Shloka",
  chat:"Ask the Gita",
  journal:"Spiritual Journal",
  profile:"My Profile",
  bookclub:"Gita Book Club",
  ramayana:"Ramayana Club",
  puja:"Online Puja Booking",
  jyotish:"Jyotish · Astrology",
  browse:"Browse by Theme",
  panchang:"Panchang",
  satsang:"Satsang Circles",
};

// ── Push notification helpers ─────────────────────────────────────────────────

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64  = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw     = window.atob(base64);
  return Uint8Array.from([...raw].map(c => c.charCodeAt(0)));
}

async function setupPush(userId) {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) return;
  try {
    const reg  = await navigator.serviceWorker.register("/sw.js");
    const perm = await Notification.requestPermission();
    if (perm !== "granted") return;

    const keyRes = await fetch(`${API}/notifications/vapid-key`);
    const { public_key } = await keyRes.json();
    if (!public_key) return;   // VAPID not configured — skip silently

    const sub = await reg.pushManager.subscribe({
      userVisibleOnly:      true,
      applicationServerKey: urlBase64ToUint8Array(public_key),
    });
    await fetch(`${API}/notifications/subscribe`, {
      method:  "POST",
      headers: { "Content-Type": "application/json" },
      body:    JSON.stringify({ user_id: userId, subscription: sub.toJSON() }),
    });
  } catch { /* non-critical — app works without notifications */ }
}

// ── Puja guest entry wrapper — bell ceremony is inside GuestPujaLanding ──────
// Bell entry ceremony now lives inside GuestPujaLanding (PujaPage.js).
// This wrapper just renders PujaPage directly.
function PujaGuestWrapper({ onLoginRequired }) {
  return <PujaPage user={null} onLoginRequired={onLoginRequired} />;
}

// ── Guest user helper (persistent across page reloads) ────────────────────────
function getGuestUser() {
  let gid = localStorage.getItem("vs_guest_id");
  if (!gid) {
    gid = "guest_" + Date.now() + "_" + Math.random().toString(36).substr(2, 6);
    localStorage.setItem("vs_guest_id", gid);
  }
  return { id: gid, email: null, name: "Guest", photo: "" };
}

// ── Sticky top banner shown when browsing as guest ────────────────────────────
// ── Jyotish background — deep cosmic, single moon, sparse stars ───────────────
const JYOTISH_STARS = [
  {x:"3%",  y:"4%",  r:1,   d:"0s",    t:"3.2s"},{x:"9%",  y:"8%",  r:1.5, d:"0.7s",  t:"4.1s"},
  {x:"16%", y:"3%",  r:1,   d:"1.4s",  t:"2.8s"},{x:"24%", y:"12%", r:2,   d:"0.3s",  t:"3.7s"},
  {x:"32%", y:"5%",  r:1,   d:"1.9s",  t:"5s"},  {x:"41%", y:"9%",  r:1.5, d:"1.1s",  t:"3.4s"},
  {x:"50%", y:"3%",  r:1,   d:"2.3s",  t:"4.6s"},{x:"58%", y:"14%", r:2,   d:"0.5s",  t:"3.9s"},
  {x:"67%", y:"6%",  r:1,   d:"1.6s",  t:"4.3s"},{x:"76%", y:"11%", r:1.5, d:"2.1s",  t:"3.1s"},
  {x:"84%", y:"4%",  r:1,   d:"0.9s",  t:"4.8s"},{x:"93%", y:"8%",  r:1,   d:"1.3s",  t:"3.6s"},
  {x:"7%",  y:"20%", r:1,   d:"0.2s",  t:"4.2s"},{x:"20%", y:"26%", r:1.5, d:"1.8s",  t:"3.0s"},
  {x:"35%", y:"22%", r:1,   d:"0.6s",  t:"5.1s"},{x:"48%", y:"30%", r:2,   d:"1.2s",  t:"3.8s"},
  {x:"62%", y:"19%", r:1,   d:"2.0s",  t:"4.4s"},{x:"75%", y:"28%", r:1.5, d:"0.4s",  t:"3.3s"},
  {x:"87%", y:"24%", r:1,   d:"1.7s",  t:"4.7s"},{x:"96%", y:"18%", r:1,   d:"0.8s",  t:"3.5s"},
  {x:"5%",  y:"40%", r:1,   d:"1.5s",  t:"4.0s"},{x:"14%", y:"48%", r:1.5, d:"0.1s",  t:"5.2s"},
  {x:"28%", y:"44%", r:1,   d:"2.2s",  t:"3.2s"},{x:"42%", y:"52%", r:1,   d:"0.9s",  t:"4.5s"},
  {x:"55%", y:"38%", r:2,   d:"1.4s",  t:"3.6s"},{x:"68%", y:"46%", r:1,   d:"0.3s",  t:"4.9s"},
  {x:"80%", y:"40%", r:1.5, d:"1.0s",  t:"3.4s"},{x:"92%", y:"52%", r:1,   d:"1.8s",  t:"4.2s"},
  {x:"11%", y:"60%", r:1,   d:"2.4s",  t:"3.7s"},{x:"25%", y:"68%", r:1.5, d:"0.6s",  t:"5.0s"},
  {x:"38%", y:"62%", r:1,   d:"1.1s",  t:"3.3s"},{x:"52%", y:"72%", r:2,   d:"1.9s",  t:"4.1s"},
  {x:"65%", y:"58%", r:1,   d:"0.4s",  t:"3.9s"},{x:"78%", y:"66%", r:1.5, d:"2.1s",  t:"4.6s"},
  {x:"90%", y:"60%", r:1,   d:"0.7s",  t:"3.1s"},{x:"2%",  y:"78%", r:1,   d:"1.3s",  t:"4.4s"},
  {x:"18%", y:"84%", r:1.5, d:"0.0s",  t:"3.8s"},{x:"33%", y:"80%", r:1,   d:"2.3s",  t:"5.3s"},
  {x:"47%", y:"88%", r:2,   d:"0.5s",  t:"3.5s"},{x:"60%", y:"82%", r:1,   d:"1.6s",  t:"4.0s"},
  {x:"73%", y:"76%", r:1.5, d:"1.2s",  t:"3.2s"},{x:"85%", y:"90%", r:1,   d:"2.0s",  t:"4.8s"},
  {x:"97%", y:"74%", r:1,   d:"0.8s",  t:"3.6s"},
];
const JYOTISH_PLANETS = [
  { w:80,  h:80,  top:"5%",  right:"8%",  bg:"radial-gradient(circle at 35% 35%, rgba(249,115,22,0.6) 0%, rgba(180,70,10,0.3) 50%, transparent 75%)", glow:"rgba(249,115,22,0.3)", dur:"7s" },
  { w:44,  h:44,  top:"35%", left:"3%",   bg:"radial-gradient(circle at 40% 30%, rgba(139,92,246,0.5) 0%, rgba(80,50,160,0.25) 55%, transparent 78%)", glow:"rgba(139,92,246,0.25)", dur:"9s" },
  { w:32,  h:32,  top:"60%", right:"5%",  bg:"radial-gradient(circle at 38% 38%, rgba(59,130,246,0.45) 0%, rgba(30,80,200,0.2) 55%, transparent 75%)", glow:"rgba(59,130,246,0.22)", dur:"11s" },
  { w:20,  h:20,  top:"22%", right:"22%", bg:"radial-gradient(circle at 40% 35%, rgba(245,158,11,0.5) 0%, rgba(180,100,10,0.25) 55%, transparent 78%)", glow:"rgba(245,158,11,0.28)", dur:"6s" },
  { w:16,  h:16,  top:"78%", left:"12%",  bg:"radial-gradient(circle at 38% 35%, rgba(236,72,153,0.4) 0%, rgba(150,40,100,0.2) 55%, transparent 78%)", glow:"rgba(236,72,153,0.22)", dur:"8s" },
];
function JyotishBackground() {
  // Flat white background — no color wash, matches the rest of the app.
  return (
    <div style={{ position:"fixed", inset:0, zIndex:1, pointerEvents:"none",
      background:"#FFFFFF" }} />
  );
}

// ── Puja background — temple sanctum. Warm amber diya light, NOT red.
// Indian mental model: dark temple stone + golden lamp light radiating from center
// Rangoli/kolam at floor level, marigold petals, incense smoke, 3 diyas
// Color philosophy: deep warm brown-black stone + amber-gold light, never red-cast
const PUJA_PETALS = [
  {x:"6%",  y:"76%", w:28, h:9,  a:-28, c:"rgba(230,140,20,0.18)"},
  {x:"13%", y:"82%", w:20, h:7,  a:12,  c:"rgba(200,100,15,0.14)"},
  {x:"20%", y:"74%", w:32, h:10, a:-42, c:"rgba(240,155,25,0.16)"},
  {x:"28%", y:"86%", w:16, h:6,  a:22,  c:"rgba(220,130,18,0.12)"},
  {x:"37%", y:"79%", w:24, h:8,  a:-18, c:"rgba(235,148,22,0.15)"},
  {x:"63%", y:"81%", w:22, h:7,  a:15,  c:"rgba(228,138,20,0.14)"},
  {x:"72%", y:"76%", w:26, h:9,  a:-35, c:"rgba(240,155,25,0.16)"},
  {x:"80%", y:"85%", w:18, h:6,  a:30,  c:"rgba(210,118,17,0.13)"},
  {x:"88%", y:"73%", w:30, h:10, a:-50, c:"rgba(235,148,22,0.17)"},
  {x:"94%", y:"83%", w:16, h:5,  a:8,   c:"rgba(228,138,20,0.11)"},
  {x:"44%", y:"89%", w:20, h:7,  a:-22, c:"rgba(240,155,25,0.13)"},
  {x:"56%", y:"87%", w:24, h:8,  a:18,  c:"rgba(228,138,20,0.14)"},
];
const PUJA_SPARKS = [
  {x:"29%", y:"46%", r:1,   d:"0s",   t:"3.8s"}, {x:"31%", y:"42%", r:1.5, d:"1.1s", t:"4.5s"},
  {x:"49%", y:"38%", r:1.5, d:"0.4s", t:"3.5s"}, {x:"51%", y:"34%", r:2,   d:"1.6s", t:"4.2s"},
  {x:"69%", y:"45%", r:1,   d:"0.9s", t:"4.0s"}, {x:"71%", y:"41%", r:1.5, d:"2.1s", t:"3.6s"},
  {x:"48%", y:"30%", r:1,   d:"0.7s", t:"5.1s"}, {x:"52%", y:"28%", r:1,   d:"1.8s", t:"3.9s"},
  {x:"32%", y:"50%", r:1,   d:"2.3s", t:"4.8s"}, {x:"70%", y:"50%", r:1,   d:"0.5s", t:"4.1s"},
];

function PujaBackground() {
  return (
    <div style={{
      position:"fixed", inset:0, zIndex:1, pointerEvents:"none",
      background:"linear-gradient(180deg, #020201 0%, #050400 40%, #080600 100%)",
    }}>
      {/* ── Warm amber glow from center ── */}
      <div style={{
        position:"absolute", top:"30%", left:"50%", transform:"translateX(-50%)",
        width:900, height:700, borderRadius:"50%",
        background:"radial-gradient(ellipse, rgba(255,165,40,0.07) 0%, rgba(220,130,30,0.035) 38%, transparent 68%)",
        animation:"glow-pulse 4s ease-in-out infinite",
      }}/>

      {/* ── Temple vignette ── */}
      <div style={{
        position:"absolute", inset:0,
        background:"radial-gradient(ellipse 72% 65% at 50% 48%, transparent 25%, rgba(18,12,2,0.72) 100%)",
      }}/>

      {/* ── THREE AUTHENTIC OIL DIYAS (clay lamps, not candles) ── */}
      {/* center diya slightly larger; left & right smaller */}
      {[
        { left:"50%", bottom:"20%", s:1.35, p:["3.0s","2.8s"], d:["0s","0.25s"] },
        { left:"30%", bottom:"18%", s:1.0,  p:["3.4s","3.1s"], d:["0.5s","0.7s"] },
        { left:"70%", bottom:"18%", s:1.0,  p:["3.6s","3.3s"], d:["1.1s","1.3s"] },
      ].map(({ left, bottom, s, p, d }, di) => {
        const W  = s;                       // scale factor
        const bw = 48 * W;                  // clay bowl width
        const bh = 16 * W;                  // clay bowl height
        const fw = 9  * W;                  // flame width
        const fh = 22 * W;                  // flame height — SHORT like real diya
        const gw = 90 * W;                  // floor glow width
        return (
          <div key={di} style={{ position:"absolute", left, bottom, transform:"translateX(-50%)" }}>

            {/* Floor oil glow — warm pool on surface */}
            <div style={{
              position:"absolute", bottom: -6*W, left:"50%", transform:"translateX(-50%)",
              width: gw, height: gw * 0.35, borderRadius:"50%",
              background:"radial-gradient(ellipse, rgba(255,155,30,0.14) 0%, transparent 70%)",
              animation:`glow-pulse ${p[1]} ${d[1]} ease-in-out infinite`,
            }}/>

            {/* Flame halo glow */}
            <div style={{
              position:"absolute", bottom: bh + 2*W, left:"50%", transform:"translateX(-50%)",
              width: 36*W, height: 36*W, borderRadius:"50%",
              background:"radial-gradient(ellipse, rgba(255,140,0,0.38) 0%, rgba(255,100,0,0.15) 45%, transparent 72%)",
              animation:`glow-pulse ${p[0]} ${d[0]} ease-in-out infinite`,
            }}/>

            {/* Outer flame blur — warm orange haze */}
            <div style={{
              position:"absolute", bottom: bh + 2*W, left:"50%", transform:"translateX(-50%)",
              width: fw * 2.2, height: fh * 1.1,
              background:"linear-gradient(0deg, rgba(230,100,10,0.55) 0%, rgba(255,140,30,0.25) 55%, transparent 100%)",
              borderRadius:"50% 50% 35% 35% / 55% 55% 45% 45%",
              filter:"blur(5px)",
              animation:`flame-breathe ${p[0]} ${d[0]} ease-in-out infinite`,
              transformOrigin:"bottom center",
            }}/>

            {/* Main flame — saffron teardrop */}
            <div style={{
              position:"absolute", bottom: bh + 4*W, left:"50%", transform:"translateX(-50%)",
              width: fw, height: fh,
              background:"linear-gradient(0deg, rgba(255,120,10,0.95) 0%, rgba(255,190,50,0.85) 48%, rgba(255,240,140,0.6) 78%, transparent 100%)",
              borderRadius:"50% 50% 30% 30% / 58% 58% 42% 42%",
              filter:"blur(0.5px)",
              animation:`flame-breathe ${p[1]} ${d[1]} ease-in-out infinite`,
              transformOrigin:"bottom center",
            }}/>

            {/* Inner flame core — bright gold */}
            <div style={{
              position:"absolute", bottom: bh + 5*W, left:"50%", transform:"translateX(-50%)",
              width: fw * 0.45, height: fh * 0.55,
              background:"linear-gradient(0deg, rgba(255,220,80,1) 0%, rgba(255,248,180,0.85) 55%, transparent 100%)",
              borderRadius:"50% 50% 30% 30% / 58% 58% 42% 42%",
              animation:`flame-breathe ${p[0]} ${d[0]} ease-in-out infinite reverse`,
              transformOrigin:"bottom center",
            }}/>

            {/* Wick */}
            <div style={{
              position:"absolute", bottom: bh + 1*W, left:"50%", transform:"translateX(-50%)",
              width: 2*W, height: 6*W,
              background:"linear-gradient(0deg, #2A1400, #4A2800)",
              borderRadius: 2,
            }}/>

            {/* Clay diya body — wide, low, round like real diya */}
            <div style={{
              position:"absolute", bottom:0, left:"50%", transform:"translateX(-50%)",
              width: bw, height: bh,
              background:"radial-gradient(ellipse at 50% 35%, #C87838 0%, #9E5020 50%, #6E3010 100%)",
              borderRadius:"50%",
              boxShadow:`0 3px 10px rgba(0,0,0,0.55), inset 0 -3px 5px rgba(0,0,0,0.25), 0 0 ${12*W}px rgba(200,100,20,0.2)`,
            }}>
              {/* Oil surface inside diya — reflective pool */}
              <div style={{
                position:"absolute", top: 2*W, left:"50%", transform:"translateX(-50%)",
                width: bw * 0.6, height: bh * 0.55,
                background:"radial-gradient(ellipse, rgba(255,170,50,0.45) 0%, rgba(200,100,20,0.2) 65%, transparent)",
                borderRadius:"50%",
              }}/>
            </div>

            {/* Ground shadow */}
            <div style={{
              position:"absolute", bottom: -4*W, left:"50%", transform:"translateX(-50%)",
              width: bw * 1.1, height: 5*W, borderRadius:"50%",
              background:"rgba(0,0,0,0.35)", filter:"blur(4px)",
            }}/>

          </div>
        );
      })}

      {/* ── Altar platform line ── */}
      <div style={{
        position:"absolute", bottom:"18%", left:"5%", right:"5%", height:1,
        background:"linear-gradient(90deg, transparent, rgba(200,140,30,0.12) 20%, rgba(230,165,45,0.18) 50%, rgba(200,140,30,0.12) 80%, transparent)",
      }}/>

      {/* ── Marigold petal scatter ── */}
      {PUJA_PETALS.map((p,i) => (
        <div key={i} style={{
          position:"absolute", left:p.x, top:p.y,
          width:p.w, height:p.h, borderRadius:"50%",
          background:p.c, transform:`rotate(${p.a}deg)`,
        }}/>
      ))}

      {/* ── Aarti gold sparks ── */}
      {PUJA_SPARKS.map((s,i) => (
        <div key={i} style={{
          position:"absolute", left:s.x, top:s.y,
          width:s.r*2, height:s.r*2, borderRadius:"50%",
          background:s.r>1.3 ? "rgba(255,215,70,0.88)" : "rgba(255,185,55,0.72)",
          animation:`star-twinkle ${s.t} ${s.d} ease-in-out infinite`,
          boxShadow:s.r>1.3 ? "0 0 6px rgba(255,200,60,0.6)" : "none",
        }}/>
      ))}

      {/* ── Top gradient — dark ceiling ── */}
      <div style={{
        position:"absolute", top:0, left:0, right:0, height:"45%",
        background:"linear-gradient(180deg, rgba(2,2,1,0.88) 0%, transparent 100%)",
      }}/>
      <div style={{
        position:"absolute", top:0, left:"50%", transform:"translateX(-50%)",
        width:420, height:3,
        background:"linear-gradient(90deg, transparent, rgba(220,165,45,0.15) 30%, rgba(235,180,55,0.22) 50%, rgba(220,165,45,0.15) 70%, transparent)",
      }}/>
    </div>
  );
}

function GuestBanner({ onSignIn, onBack, theme = "spiritual" }) {
  const borderColor = theme === "jyotish" ? "rgba(155,143,212,0.35)" : theme === "puja" ? "rgba(232,92,42,0.3)" : "rgba(232,131,42,0.3)";
  const bgColor = theme === "jyotish" ? "rgba(250,248,255,0.95)" : theme === "puja" ? "rgba(255,247,241,0.95)" : "rgba(255,253,248,0.95)";
  return (
    <div style={{
      position: "fixed", top: 0, left: 0, right: 0, zIndex: 9999,
      background: bgColor, backdropFilter: "blur(12px)",
      borderBottom: `1px solid ${borderColor}`,
      boxShadow: "0 2px 12px rgba(176,120,30,0.08)",
      display: "flex", alignItems: "center", justifyContent: "space-between",
      padding: "10px 24px", gap: "12px", flexWrap: "wrap",
    }}>
      <button onClick={onBack} style={{
        background: "transparent", border: "1px solid rgba(201,149,58,0.3)",
        borderRadius: "8px", padding: "5px 14px", color: "var(--text-dim)",
        fontFamily: "'Crimson Pro',serif", fontSize: "0.9rem", cursor: "pointer",
      }}>← Vedsanga</button>
      <div style={{ fontSize: "0.88rem", color: "var(--text-dim)", fontStyle: "italic", flex: 1, textAlign: "center" }}>
        You're browsing as guest — your selections are saved locally
      </div>
      <button onClick={onSignIn} style={{
        background: "linear-gradient(135deg, var(--saffron), var(--gold))",
        border: "none", borderRadius: "8px", padding: "7px 18px",
        color: "white", fontFamily: "'Cinzel Decorative',serif",
        fontSize: "0.78rem", cursor: "pointer", letterSpacing: "0.04em",
        whiteSpace: "nowrap",
      }}>
        Create free account →
      </button>
    </div>
  );
}

export default function App() {
  const [user,           setUser]           = useState(null);
  usePushNotifications(user);   // registers SW + subscribes after login
  // /?page=puja opens a page directly (used by "Book puja" buttons in Jyotish)
  const _linkedPage = new URLSearchParams(window.location.search).get("page");
  const [page,           setPage]           = useState(["puja", "consult", "family-reports"].includes(_linkedPage) ? _linkedPage : "home");
  const [companionCtx,   setCompanionCtx]   = useState(null);
  const [chatInitText,   setChatInitText]   = useState("");
  const [shlokaInitVerse, setShlokaInitVerse] = useState(null);
  const [onboarding,     setOnboarding]     = useState(false);
  const [loading,        setLoading]        = useState(true);
  const [streak,         setStreak]         = useState(0);
  const [showLogin,      setShowLogin]      = useState(false);
  const [guestPage,      setGuestPage]      = useState(_linkedPage === "puja" ? "puja" : null); // "puja" | "jyotish" | null
  // /?page=archetype and /?page=milan — free shareable pages (no login)
  const [publicPage,     setPublicPage]     = useState(["archetype", "milan", "astrologer", "astro-desk"].includes(_linkedPage) ? _linkedPage : null);
  const [preferredLang,  setPreferredLang]  = useState("en");
  const [appLang,        setAppLang]        = useState(() => localStorage.getItem("app_lang") || localStorage.getItem("panchang_lang") || "en");
  const [appScript,      setAppScript]      = useState(() => localStorage.getItem("jyotish_script_pref") || "native");
  const [sidebarTheme,   setSidebarTheme]   = useState(() => localStorage.getItem("sb-theme") || "light");
  const toggleSidebarTheme = () => setSidebarTheme(t => { const n = t === "light" ? "dark" : "light"; localStorage.setItem("sb-theme", n); return n; });
  const [mobNavOpen,     setMobNavOpen]     = useState(false);
  const [isMobile,       setIsMobile]       = useState(() => window.matchMedia("(max-width: 767px)").matches);
  const [sidebarOpen,    setSidebarOpen]    = useState(true);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 767px)");
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  // Deep pages (Jyotish results, report store) open money pages with
  // window.dispatchEvent(new CustomEvent("vs:navigate", { detail: "consult" })).
  useEffect(() => {
    const go = (e) => { setPage(e.detail); window.scrollTo(0, 0); };
    window.addEventListener("vs:navigate", go);
    return () => window.removeEventListener("vs:navigate", go);
  }, []);

  const checkOnboarding = (uid) => {
    const done = localStorage.getItem(`vedsanga_onboarded_${uid}`);
    if (!done) setOnboarding(true);
  };

  const loadPreferredLang = (uid) => {
    fetch(`${API}/user/language/${encodeURIComponent(uid)}`)
      .then(r => r.json())
      .then(d => {
        if (d.lang_code) {
          setPreferredLang(d.lang_code);
          // Sync to appLang if not already set by user
          if (!localStorage.getItem("app_lang")) {
            setAppLang(d.lang_code);
            localStorage.setItem("app_lang", d.lang_code);
            localStorage.setItem("panchang_lang", d.lang_code);
          }
        }
      })
      .catch(() => {});
  };

  const handleAppLangChange = (lang, script) => {
    setAppLang(lang);
    setAppScript(script);
    localStorage.setItem("app_lang", lang);
    localStorage.setItem("panchang_lang", lang);       // backward compat
    localStorage.setItem("jyotish_script_pref", script);
    // preferredLang for Shloka page = base lang (no roman suffix)
    const baseLang = lang.replace("_roman", "") || lang;
    setPreferredLang(baseLang);
    // Sync to server
    if (user?.id) {
      fetch(`${API}/user/language?user_id=${encodeURIComponent(user.id)}&lang_code=${baseLang}`, { method: "POST" }).catch(() => {});
    }
  };

  // Persist session across browser refreshes
  useEffect(() => {
    const buildUser = async (supaUser) => {
      const m        = supaUser.user_metadata || {};
      const rawName  = m.full_name || m.name || "";
      // Never use full email as name — extract readable part from email prefix
      const name     = rawName || supaUser.email.split("@")[0].replace(/[._]/g, " ").replace(/\b\w/g, c => c.toUpperCase());
      // Load uploaded avatar from our backend (overrides OAuth photo)
      let photo = m.avatar_url || m.picture || "";
      try {
        const r = await fetch(`${API}/user/avatar/${supaUser.id}`);
        const d = await r.json();
        if (d.photo_url) photo = d.photo_url;
      } catch {}
      return { name, email: supaUser.email, id: supaUser.id, photo };
    };

    const devUser = getDevUser();
    if (devUser) {
      setUser(devUser);
      checkOnboarding(devUser.id);
      setLoading(false);
      return;
    }

    supabase.auth.getSession().then(async ({ data: { session } }) => {
      if (session?.user) {
        const u = await buildUser(session.user);
        setUser(u);
        checkOnboarding(u.id);
        loadPreferredLang(u.id);
      }
      setLoading(false);
    }).catch(() => setLoading(false)); // auth unreachable / lock stolen — continue as guest

    // Listen for Google OAuth redirect + auth changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      async (_event, session) => {
        if (session?.user) {
          const u = await buildUser(session.user);
          setUser(u);
          checkOnboarding(u.id);
          loadPreferredLang(u.id);
          setLoading(false);
        } else {
          setUser(null);
          setLoading(false);
        }
      }
    );
    return () => subscription.unsubscribe();
  }, []);

  // Fetch streak + setup push when user is set
  useEffect(() => {
    if (!user) return;
    fetch(`${API}/journey/streak/${encodeURIComponent(user.id)}`)
      .then(r => r.json())
      .then(d => setStreak(d.streak || 0))
      .catch(() => {});
    setupPush(user.id);
  }, [user]);

  const refreshStreak = () => {
    if (!user) return;
    fetch(`${API}/journey/streak/${encodeURIComponent(user.id)}`)
      .then(r => r.json())
      .then(d => setStreak(d.streak || 0))
      .catch(() => {});
  };

  const handleOnboardingComplete = () => {
    localStorage.setItem(`vedsanga_onboarded_${user.id}`, "1");
    setOnboarding(false);
    setPage("home");
  };

  const handleAskGita = (text) => {
    setChatInitText(text);
    setPage("chat");
  };

  // ── Priest URL-param routing (no login required) ─────────────────────────────
  const _urlParams       = new URLSearchParams(window.location.search);
  const _priestBooking   = _urlParams.get("priest");
  const _priestSecret    = _urlParams.get("secret");
  const _priestDashboard = _urlParams.get("priest_dashboard");
  const _priestRegister  = _urlParams.get("priest_register");

  // /?priest=<booking_id>&secret=<admin_secret>  → join a live puja session
  if (_priestBooking && _priestSecret) {
    return <PriestJoinPage bookingId={_priestBooking} secret={_priestSecret} />;
  }
  // /?priest_dashboard=<priest_id>&secret=<admin_secret>  → priest dashboard
  if (_priestDashboard && _priestSecret) {
    return <PriestDashboardPage priestId={_priestDashboard} secret={_priestSecret} />;
  }
  // /?priest_register=1  → public registration form
  if (_priestRegister) {
    return <PriestRegisterPage />;
  }
  // /?admin=1  → internal admin dashboard (its own secret gate, not URL-based)
  if (_urlParams.get("admin")) {
    return <AdminPage />;
  }
  // /?altar=<booking_id>&secret=<admin_secret>  → shrine/altar cam (second device)
  const _altarBooking = _urlParams.get("altar");
  if (_altarBooking && _priestSecret) {
    return <PriestAltarPage bookingId={_altarBooking} secret={_priestSecret} />;
  }
  // /?priest_monitor=<booking_id>&secret=<admin_secret>  → priest's silent control panel
  const _monitorBooking = _urlParams.get("priest_monitor");
  if (_monitorBooking && _priestSecret) {
    return <PriestMonitorPage bookingId={_monitorBooking} secret={_priestSecret} />;
  }
  // /?milan_id=<id>&token=<uuid>  → Kundali Milan paid report (WhatsApp payment link)
  const _milanId    = _urlParams.get("milan_id");
  const _milanToken = _urlParams.get("token");
  if (_milanId) {
    return <MilanReportPage milanId={_milanId} token={_milanToken} />;
  }
  // /?shani_id=<id>&token=<uuid>  → Shani Analysis paid report (WhatsApp payment link)
  const _shaniId    = _urlParams.get("shani_id");
  const _shaniToken = _urlParams.get("token");
  if (_shaniId) {
    return <ShaniReportPage shaniId={_shaniId} token={_shaniToken} />;
  }
  // /?kundali_id=<id>&kundali_token=<uuid>  → Full Kundali paid report (WhatsApp payment link)
  const _kundaliId    = _urlParams.get("kundali_id");
  const _kundaliToken = _urlParams.get("kundali_token");
  if (_kundaliId) {
    return <KundaliReportPage kundaliId={_kundaliId} token={_kundaliToken} />;
  }

  if (publicPage) {
    const onFullReading = () => {
      window.history.replaceState(null, "", "/");
      setPublicPage(null);
      if (user) setPage("jyotish"); else setGuestPage("jyotish");
      window.scrollTo(0, 0);
    };
    if (publicPage === "astrologer") return <AstrologerJoinPage />;
    if (publicPage === "astro-desk") return <AstroDeskPage />;
    return publicPage === "milan"
      ? <MilanQuizPage onFullReading={onFullReading} />
      : <ArchetypeQuizPage onFullReading={onFullReading} />;
  }

  if (loading) return (
    <div className="loading-screen">
      <div className="loading-om">ॐ</div>
      <div style={{color:"var(--text-dim)",fontStyle:"italic"}}>Loading Vedsanga...</div>
    </div>
  );

  if (!user) {
    if (showLogin) return <LoginPage onLogin={u => { setUser(u); setShowLogin(false); setGuestPage(null); }} />;

    // Guest browsing — real pages, login gate only at action points
    if (guestPage === "puja") {
      return (
        <div style={{ minHeight:"100vh", position:"relative" }}>
          <PujaBackground />
          <div style={{ position:"relative", zIndex:2, paddingTop:"52px" }}>
            <GuestBanner theme="puja" onSignIn={() => setShowLogin(true)} onBack={() => { setGuestPage(null); window.scrollTo(0,0); }} />
            <PujaGuestWrapper onLoginRequired={() => setShowLogin(true)} />
          </div>
        </div>
      );
    }
    if (guestPage === "jyotish") {
      const guestUser = getGuestUser();
      return (
        <div style={{ minHeight:"100vh", position:"relative" }}>
          <JyotishBackground />
          <style>{`.guest-jyotish-wrap .page { margin: 0 auto; }`}</style>
          <div className="guest-jyotish-wrap" style={{ position:"relative", zIndex:2, paddingTop:"52px" }}>
            <GuestBanner theme="jyotish" onSignIn={() => setShowLogin(true)} onBack={() => { setGuestPage(null); window.scrollTo(0,0); }} />
            <JyotishPage user={guestUser} onBack={() => { setGuestPage(null); window.scrollTo(0,0); }} />
          </div>
        </div>
      );
    }

    return (
      <LandingPage
        onGetStarted={() => setShowLogin(true)}
        onSignIn={() => setShowLogin(true)}
        onGoPuja={() => { setGuestPage("puja"); window.scrollTo(0, 0); }}
        onGoJyotish={() => { setGuestPage("jyotish"); window.scrollTo(0, 0); }}
      />
    );
  }

  if (onboarding && user) {
    return <OnboardingPage user={user} onComplete={handleOnboardingComplete} />;
  }

  const navItemClick = (id) => {
    if (id === "shloka") setShlokaInitVerse(null);
    setPage(id);
    setMobNavOpen(false);
  };

  const renderMobNavItems = () => (
    <nav className="nav">
      {NAV.reduce((acc, item, i) => {
        const prev = NAV[i - 1];
        if (!prev || prev.group !== item.group) {
          const labels = { practice: "Practice", tools: "My Account" };
          if (labels[item.group]) acc.push(<div key={`label-${item.group}`} className="nav-section-label">{labels[item.group]}</div>);
        }
        acc.push(
          <div key={item.id} className={`nav-item ${page===item.id?"active":""}`} onClick={() => navItemClick(item.id)}>
            <span className="nav-icon">{item.icon}</span>
            <span style={{ flex: 1 }}>{item.label}</span>
            {item.id === "journey" && streak > 0 && (
              <span style={{ background:"linear-gradient(135deg,#ff6b2b,#ff4500)", color:"white", borderRadius:"12px", padding:"2px 8px", fontSize:"0.78rem", fontWeight:"700", flexShrink:0 }}>
                🔥 {streak}
              </span>
            )}
          </div>
        );
        return acc;
      }, [])}
    </nav>
  );

  /* ── shared colours ── */
  const sbBg   = sidebarTheme === "light"
    ? "linear-gradient(180deg,rgba(255,232,138,0.98) 0%,rgba(255,248,216,0.99) 50%,rgba(255,232,138,0.97) 100%)"
    : "linear-gradient(170deg,#2A1405 0%,#3D1E08 18%,#1E0D03 40%,#2C1606 65%,#180A02 100%)";
  const sbShadow = "8px 0 40px rgba(0,0,0,0.22)";
  const closeBtnStyle = {
    position:"absolute", top:12, right:12, zIndex:10,
    width:32, height:32, borderRadius:"50%", border:"none", cursor:"pointer",
    background:"rgba(0,0,0,0.12)", color:"inherit", fontSize:"1rem",
    display:"flex", alignItems:"center", justifyContent:"center",
  };
  const BOTTOM_NAV_ITEMS = [
    {id:"home",    icon:"🏠", label:"Home"},
    {id:"today",   icon:"🕉️", label:"Today"},
    {id:"chat",    icon:"💬", label:"Ask Gita"},
    {id:"jyotish", icon:"⭐", label:"Jyotish"},
  ];
  const MORE_PAGES = ["consult","family-reports","journey","sacredtexts","bookclub","ramayana","satsang","puja","daily-puja","shloka","journal","profile","panchang","browse"];

  return (
    <>
    {page === "jyotish" && <JyotishBackground />}

    {/* ── Mobile overlay (tap to close drawer) ── */}
    {isMobile && (
      <div onClick={() => setMobNavOpen(false)} style={{
        position:"fixed", inset:0, zIndex:498,
        background:"rgba(0,0,0,0.5)",
        opacity: mobNavOpen ? 1 : 0,
        pointerEvents: mobNavOpen ? "all" : "none",
        transition:"opacity 0.28s",
      }} />
    )}

    {/* ── Mobile slide-in nav drawer (fully inline styles) ── */}
    {isMobile && (
      <aside className={`sb-${sidebarTheme}`} style={{
        position:"fixed", top:0, left:0, bottom:0, width:280, zIndex:499,
        display:"flex", flexDirection:"column", overflowY:"auto", overflowX:"hidden",
        background:sbBg, boxShadow:sbShadow,
        transform: mobNavOpen ? "translateX(0)" : "translateX(-100%)",
        transition:"transform 0.3s cubic-bezier(.4,0,.2,1)",
      }}>
        <button onClick={() => setMobNavOpen(false)} aria-label="Close" style={closeBtnStyle}>✕</button>
        <div className="sidebar-logo" style={{ paddingTop:52 }}>
          <span className="logo-om">ॐ</span>
          <div className="logo-name">Vedsanga</div>
          <div className="logo-tagline">वेदसङ्ग</div>
        </div>
        {renderMobNavItems()}
        <div className="sidebar-divider" />
        <div className="sb-theme-toggle" onClick={toggleSidebarTheme}>
          {sidebarTheme === "light" ? "🌙 Night Mode" : "☀️ Day Mode"}
        </div>
        <div className="sidebar-footer">Vedsanga • वेदसङ्ग<br/>Daily Divine Wisdom</div>
      </aside>
    )}

    <div className="app">
      {/* ── Desktop sidebar (not rendered on mobile at all) ── */}
      {!isMobile && sidebarOpen && (
        <>
          {/* overlay for narrow desktop — tap outside to close */}
          <div onClick={() => setSidebarOpen(false)} style={{
            position:"fixed", inset:0, zIndex:99,
            background:"rgba(0,0,0,0.35)",
            display: window.innerWidth < 1100 ? "block" : "none",
          }} />
          <aside className={`sidebar sb-${sidebarTheme}`}>
            <button onClick={() => setSidebarOpen(false)} aria-label="Close sidebar" style={closeBtnStyle}>✕</button>
            <div className="sidebar-logo">
              <span className="logo-om">ॐ</span>
              <div className="logo-name">Vedsanga</div>
              <div className="logo-tagline">वेदसङ्ग</div>
            </div>
            <nav className="nav">
              {NAV.reduce((acc, item, i) => {
                const prev = NAV[i - 1];
                if (!prev || prev.group !== item.group) {
                  const labels = { practice:"Practice", tools:"My Account" };
                  if (labels[item.group]) acc.push(<div key={`label-${item.group}`} className="nav-section-label">{labels[item.group]}</div>);
                }
                acc.push(
                  <div key={item.id} className={`nav-item ${page===item.id?"active":""}`}
                    onClick={() => { if (item.id==="shloka") setShlokaInitVerse(null); setPage(item.id); }}>
                    <span className="nav-icon">{item.icon}</span>
                    <span style={{ flex:1 }}>{item.label}</span>
                    {item.id==="journey" && streak>0 && (
                      <span style={{ background:"linear-gradient(135deg,#ff6b2b,#ff4500)", color:"white", borderRadius:"12px", padding:"2px 8px", fontSize:"0.78rem", fontWeight:"700", flexShrink:0 }}>
                        🔥 {streak}
                      </span>
                    )}
                  </div>
                );
                return acc;
              }, [])}
            </nav>
            <div className="sb-theme-toggle" onClick={toggleSidebarTheme}>
              {sidebarTheme === "light" ? "🌙 Night Mode" : "☀️ Day Mode"}
            </div>
            <div className="sidebar-footer">Vedsanga • वेदसङ्ग<br/>Daily Divine Wisdom</div>
          </aside>
        </>
      )}

      <main className={`main${page==="chat" ? " chat-page" : ""}`}
        style={{ marginLeft: (!isMobile && sidebarOpen) ? undefined : 0, paddingBottom: isMobile ? 64 : undefined }}>
        <div className="topbar">
          <div style={{ display:"flex", alignItems:"center", gap:"10px" }}>
            {/* Hamburger on desktop when sidebar closed, or on mobile (opens drawer) */}
            {(!isMobile && !sidebarOpen) && (
              <button onClick={() => setSidebarOpen(true)} aria-label="Open sidebar" style={{ background:"none", border:"none", cursor:"pointer", padding:"4px 6px", fontSize:"1.3rem", color:"var(--saffron)", lineHeight:1 }}>☰</button>
            )}
            <span className="logo-om" style={{ fontSize:"1.4rem", display: isMobile ? "block" : "none" }}>ॐ</span>
            <div className="topbar-title">{PAGE_TITLES[page] || "Vedsanga"}</div>
          </div>
          <div className="user-pill" onClick={() => setPage("profile")}>
            {user.photo ? (
              <img src={user.photo} alt={user.name} style={{ width:28, height:28, borderRadius:"50%", objectFit:"cover" }} referrerPolicy="no-referrer" />
            ) : (
              <div className="avatar">{user.name[0].toUpperCase()}</div>
            )}
            <span className="user-pill-name">{user.name}</span>
          </div>
        </div>
        {page==="home"          && <HomePage user={user} onNavigate={setPage} onAskGita={handleAskGita} onOpenCompanion={() => setPage("journey")} appLang={appLang} appScript={appScript} onLangChange={handleAppLangChange} />}
        {page==="today"         && <TodayPage user={user} onNavigate={p => { if (p==="shloka") setShlokaInitVerse(null); setPage(p); }} streak={streak} />}
        {page==="journey"       && <JourneyPage user={user} onOpenCompanion={ctx => { setCompanionCtx(ctx); setPage("chat"); }} onStreakUpdate={refreshStreak} />}
        {page==="sacredtexts"   && <SacredTextsPage user={user} />}
        {page==="satsang"       && <SatsangPage user={user} />}
        {page==="bookclub"      && <BookClubPage user={user} />}
        {page==="ramayana"      && <RamayanaClubPage user={user} />}
        {page==="panchang"      && <PanchangPage onBack={() => setPage("home")} user={user} />}
        {page==="jyotish"       && <div style={{flex:1,minHeight:"100%"}}><JyotishPage user={user} onBack={() => setPage("home")} appLang={appLang} appScript={appScript} /></div>}
        {page==="consult"       && <ConsultPage user={user} lang={appLang} />}
        {page==="family-reports" && <MomentReportsPage user={user} lang={appLang} onTalk={() => setPage("consult")} />}
        {page==="daily-puja"    && <VirtualPujaPage user={user} />}
        {page==="puja"          && <PujaPage user={user} />}
        {page==="browse"        && <BrowsePage appLang={appLang} appScript={appScript} onLangChange={handleAppLangChange} />}
        {page==="shloka"        && <ShlokaPage key={shlokaInitVerse ? `${shlokaInitVerse.theme}-${shlokaInitVerse.chapter}-${shlokaInitVerse.verse}` : "daily"} user={user} initVerse={shlokaInitVerse} initTheme={shlokaInitVerse?.theme || ""} preferredLang={preferredLang} />}
        {page==="shloka"        && <DakshinaCard user={user} lang={appLang} />}
        {page==="chat"          && <ChatPage user={user} companionCtx={companionCtx} onCompanionCtxUsed={() => setCompanionCtx(null)} initText={chatInitText} onInitTextUsed={() => setChatInitText("")} onNavigate={setPage} />}
        {page==="journal"       && <JournalPage />}
        {page==="profile"       && <ProfilePage user={user} onLogout={() => setUser(null)} onOpenShloka={v => { setShlokaInitVerse(v); setPage("shloka"); }} preferredLang={preferredLang} onLangChange={setPreferredLang} onUserUpdate={u => setUser(prev => ({ ...prev, ...u }))} />}
      </main>

      {/* ── Mobile bottom tab bar (fully inline styles) ── */}
      {isMobile && (
        <nav style={{
          position:"fixed", bottom:0, left:0, right:0, height:64,
          display:"flex", alignItems:"stretch",
          background:"linear-gradient(180deg,rgba(255,232,138,0.97),rgba(255,248,216,0.99))",
          borderTop:"2px solid #E8C048",
          backdropFilter:"blur(16px)", zIndex:200,
          paddingBottom:"env(safe-area-inset-bottom,0px)",
        }}>
          {BOTTOM_NAV_ITEMS.map(item => (
            <button key={item.id} onClick={() => navItemClick(item.id)} style={{
              flex:1, display:"flex", flexDirection:"column", alignItems:"center",
              justifyContent:"center", gap:3, border:"none", background:"none",
              cursor:"pointer", fontSize:"0.65rem", letterSpacing:"0.04em",
              color: page===item.id ? "#C87010" : "#8A6020",
              WebkitTapHighlightColor:"transparent", position:"relative",
            }}>
              <span style={{ fontSize:"1.4rem", lineHeight:1 }}>{item.icon}</span>
              <span>{item.label}</span>
              {item.id==="journey" && streak>0 && (
                <span style={{ position:"absolute", top:4, right:"calc(50% - 22px)", background:"linear-gradient(135deg,#ff6b2b,#ff4500)", color:"white", borderRadius:8, padding:"1px 5px", fontSize:"0.6rem", fontWeight:700 }}>
                  🔥{streak}
                </span>
              )}
            </button>
          ))}
          <button onClick={() => setMobNavOpen(true)} style={{
            flex:1, display:"flex", flexDirection:"column", alignItems:"center",
            justifyContent:"center", gap:3, border:"none", background:"none",
            cursor:"pointer", fontSize:"0.65rem", letterSpacing:"0.04em",
            color: MORE_PAGES.includes(page) ? "#C87010" : "#8A6020",
            WebkitTapHighlightColor:"transparent",
          }}>
            <span style={{ fontSize:"1.4rem", lineHeight:1 }}>☰</span>
            <span>More</span>
          </button>
        </nav>
      )}

    </div>
    </>
  );
}
